msgid ""
msgstr ""
"POT-Creation-Date: 2024-08-04 21:58+0800\n"
"MIME-Version: 1.0\n"
"Content-Type: text/plain; charset=UTF-8\n"
"Content-Transfer-Encoding: 8bit\n"
"X-Generator: @lingui/cli\n"
"Language: cs\n"
"Project-Id-Version: phanpy\n"
"Report-Msgid-Bugs-To: \n"
"PO-Revision-Date: 2024-12-21 12:46\n"
"Last-Translator: \n"
"Language-Team: Czech\n"
"Plural-Forms: nplurals=4; plural=(n==1) ? 0 : (n>=2 && n<=4) ? 1 : 3;\n"
"X-Crowdin-Project: phanpy\n"
"X-Crowdin-Project-ID: 703337\n"
"X-Crowdin-Language: cs\n"
"X-Crowdin-File: /main/src/locales/en.po\n"
"X-Crowdin-File-ID: 18\n"

#: src/components/account-block.jsx:136
msgid "Locked"
msgstr "uzamčeno"

#. placeholder {0}: shortenNumber(statusesCount)
#: src/components/account-block.jsx:142
msgid "Posts: {0}"
msgstr "Příspěvky: {0}"

#. placeholder {0}: niceDateTime(lastStatusAt, { hideTime: true, })
#: src/components/account-block.jsx:147
msgid "Last posted: {0}"
msgstr "Poslední příspěvek: {0}"

#: src/components/account-block.jsx:162
#: src/components/account-info.jsx:636
msgid "Automated"
msgstr "Automaticky"

#: src/components/account-block.jsx:169
#: src/components/account-info.jsx:641
#: src/components/status.jsx:514
msgid "Group"
msgstr "Skupina"

#: src/components/account-block.jsx:179
msgid "Mutual"
msgstr "Vzájemné"

#: src/components/account-block.jsx:183
#: src/components/account-info.jsx:1682
msgid "Requested"
msgstr "Vyžadováno"

#: src/components/account-block.jsx:187
#: src/components/account-info.jsx:1673
msgid "Following"
msgstr "Sleduji"

#: src/components/account-block.jsx:191
#: src/components/account-info.jsx:1064
msgid "Follows you"
msgstr "Sleduje vás"

#: src/components/account-block.jsx:199
msgid "{followersCount, plural, one {# follower} other {# followers}}"
msgstr "{followersCount, plural, one {# odpověď} few {# odpovědi} many {# odpovědi} other {# odpovědi}}"

#: src/components/account-block.jsx:208
#: src/components/account-info.jsx:682
msgid "Verified"
msgstr "Ověřeno"

#. placeholder {0}: niceDateTime(createdAt, { hideTime: true, })
#. placeholder {0}: niceDateTime(createdAt, { hideTime: true, })
#: src/components/account-block.jsx:223
#: src/components/account-info.jsx:782
msgid "Joined <0>{0}</0>"
msgstr "Připojeno <0>{0}</0>"

#: src/components/account-info.jsx:58
msgid "Forever"
msgstr "Navždy"

#: src/components/account-info.jsx:379
msgid "Unable to load account."
msgstr "Účet nelze načíst."

#: src/components/account-info.jsx:387
msgid "Go to account page"
msgstr "Přejít na stránku účtu"

#: src/components/account-info.jsx:415
#: src/components/account-info.jsx:704
#: src/components/account-info.jsx:734
msgid "Followers"
msgstr "Sledující"

#. js-lingui-explicit-id
#: src/components/account-info.jsx:418
#: src/components/account-info.jsx:744
#: src/components/account-info.jsx:761
msgid "following.stats"
msgstr ""

#: src/components/account-info.jsx:421
#: src/components/account-info.jsx:778
#: src/pages/account-statuses.jsx:483
#: src/pages/search.jsx:328
#: src/pages/search.jsx:475
msgid "Posts"
msgstr "Příspěvky"

#: src/components/account-info.jsx:429
#: src/components/account-info.jsx:1120
#: src/components/compose.jsx:2592
#: src/components/media-alt-modal.jsx:46
#: src/components/media-modal.jsx:358
#: src/components/status.jsx:1737
#: src/components/status.jsx:1754
#: src/components/status.jsx:1878
#: src/components/status.jsx:2490
#: src/components/status.jsx:2493
#: src/pages/account-statuses.jsx:527
#: src/pages/accounts.jsx:110
#: src/pages/hashtag.jsx:200
#: src/pages/list.jsx:158
#: src/pages/public.jsx:115
#: src/pages/status.jsx:1214
#: src/pages/trending.jsx:472
msgid "More"
msgstr "Více"

#: src/components/account-info.jsx:441
msgid "<0>{displayName}</0> has indicated that their new account is now:"
msgstr "<0>{displayName}</0> naznačil, že jejich nový účet je nyní:"

#: src/components/account-info.jsx:586
#: src/components/account-info.jsx:1278
msgid "Handle copied"
msgstr "Uživatelské jméno X zkopírováno"

#: src/components/account-info.jsx:589
#: src/components/account-info.jsx:1281
msgid "Unable to copy handle"
msgstr "Nepodařilo se zkopírovat uživatelské jméno"

#: src/components/account-info.jsx:595
#: src/components/account-info.jsx:1287
msgid "Copy handle"
msgstr "Zkopírovat uživatelské jméno"

#: src/components/account-info.jsx:601
msgid "Go to original profile page"
msgstr "Přejít na původní stránku profilu"

#: src/components/account-info.jsx:608
msgid "View profile image"
msgstr "Zobrazit profilový obrázek"

#: src/components/account-info.jsx:614
msgid "View profile header"
msgstr "Zobrazit hlavičku profilu"

#: src/components/account-info.jsx:631
msgid "In Memoriam"
msgstr "In Memoriam"

#: src/components/account-info.jsx:711
#: src/components/account-info.jsx:752
msgid "This user has chosen to not make this information available."
msgstr "Tento uživatel se rozhodl nezpřístupnit tyto informace."

#. placeholder {0}: ( postingStats.originals / postingStats.total ).toLocaleString(i18n.locale || undefined, { style: 'percent', })
#. placeholder {1}: ( postingStats.replies / postingStats.total ).toLocaleString(i18n.locale || undefined, { style: 'percent', })
#. placeholder {2}: ( postingStats.boosts / postingStats.total ).toLocaleString(i18n.locale || undefined, { style: 'percent', })
#: src/components/account-info.jsx:807
msgid "{0} original posts, {1} replies, {2} boosts"
msgstr "{0} původní příspěvky, {1} odpovědi, {2} zvyšuje"

#. placeholder {0}: postingStats.total
#. placeholder {1}: postingStats.daysSinceLastPost
#. placeholder {2}: postingStats.daysSinceLastPost
#. placeholder {3}: postingStats.daysSinceLastPost
#. placeholder {4}: postingStats.total
#. placeholder {5}: postingStats.total
#. placeholder {6}: postingStats.daysSinceLastPost
#: src/components/account-info.jsx:823
msgid "{0, plural, one {{1, plural, one {Last 1 post in the past 1 day} other {Last 1 post in the past {2} days}}} other {{3, plural, one {Last {4} posts in the past 1 day} other {Last {5} posts in the past {6} days}}}}"
msgstr ""

#. placeholder {0}: postingStats.total
#. placeholder {1}: postingStats.total
#: src/components/account-info.jsx:836
msgid "{0, plural, one {Last 1 post in the past year(s)} other {Last {1} posts in the past year(s)}}"
msgstr ""

#: src/components/account-info.jsx:860
#: src/pages/catchup.jsx:70
msgid "Original"
msgstr "Originál"

#: src/components/account-info.jsx:864
#: src/components/status.jsx:2268
#: src/pages/catchup.jsx:71
#: src/pages/catchup.jsx:1445
#: src/pages/catchup.jsx:2058
#: src/pages/status.jsx:937
#: src/pages/status.jsx:1560
msgid "Replies"
msgstr "Odpovědi"

#: src/components/account-info.jsx:868
#: src/pages/catchup.jsx:72
#: src/pages/catchup.jsx:1447
#: src/pages/catchup.jsx:2070
#: src/pages/settings.jsx:1155
msgid "Boosts"
msgstr "Boosty"

#: src/components/account-info.jsx:874
msgid "Post stats unavailable."
msgstr "Statistiky příspěvku nejsou k dispozici."

#: src/components/account-info.jsx:905
msgid "View post stats"
msgstr "Zobrazit statistiky příspěvku"

#. placeholder {0}: niceDateTime(lastStatusAt, { hideTime: true, })
#: src/components/account-info.jsx:1068
msgid "Last post: <0>{0}</0>"
msgstr "Poslední příspěvek: <0>{0}</0>"

#: src/components/account-info.jsx:1082
msgid "Muted"
msgstr "Ztlumeno"

#: src/components/account-info.jsx:1087
msgid "Blocked"
msgstr "Blokováno"

#: src/components/account-info.jsx:1096
msgid "Private note"
msgstr ""

#: src/components/account-info.jsx:1153
msgid "Mention <0>@{username}</0>"
msgstr "Zmínit <0>@{username}</0>"

#: src/components/account-info.jsx:1165
msgid "Translate bio"
msgstr "Přeložit bio"

#: src/components/account-info.jsx:1176
msgid "Edit private note"
msgstr ""

#: src/components/account-info.jsx:1176
msgid "Add private note"
msgstr ""

#: src/components/account-info.jsx:1196
msgid "Notifications enabled for @{username}'s posts."
msgstr ""

#: src/components/account-info.jsx:1197
msgid " Notifications disabled for @{username}'s posts."
msgstr ""

#: src/components/account-info.jsx:1209
msgid "Disable notifications"
msgstr ""

#: src/components/account-info.jsx:1210
msgid "Enable notifications"
msgstr ""

#: src/components/account-info.jsx:1227
msgid "Boosts from @{username} enabled."
msgstr ""

#: src/components/account-info.jsx:1228
msgid "Boosts from @{username} disabled."
msgstr ""

#: src/components/account-info.jsx:1239
msgid "Disable boosts"
msgstr ""

#: src/components/account-info.jsx:1239
msgid "Enable boosts"
msgstr ""

#: src/components/account-info.jsx:1255
#: src/components/account-info.jsx:1265
#: src/components/account-info.jsx:1868
msgid "Add/Remove from Lists"
msgstr "Přidat/odebrat ze seznamu"

#: src/components/account-info.jsx:1304
#: src/components/status.jsx:1177
msgid "Link copied"
msgstr "Odkaz zkopírován"

#: src/components/account-info.jsx:1307
#: src/components/status.jsx:1180
msgid "Unable to copy link"
msgstr "Nebylo možné zkopírovat soubor"

#: src/components/account-info.jsx:1313
#: src/components/shortcuts-settings.jsx:1059
#: src/components/status.jsx:1186
#: src/components/status.jsx:3269
msgid "Copy"
msgstr "Kopírovat"

#: src/components/account-info.jsx:1328
#: src/components/shortcuts-settings.jsx:1077
#: src/components/status.jsx:1202
msgid "Sharing doesn't seem to work."
msgstr "Sdílení zřejmě nefunguje."

#: src/components/account-info.jsx:1334
#: src/components/status.jsx:1208
msgid "Share…"
msgstr "Sdílet…"

#: src/components/account-info.jsx:1354
msgid "Unmuted @{username}"
msgstr ""

#: src/components/account-info.jsx:1366
msgid "Unmute <0>@{username}</0>"
msgstr "Zrušit ztlumení <0>@{username}</0>"

#: src/components/account-info.jsx:1382
msgid "Mute <0>@{username}</0>…"
msgstr "Ztišit <0>@{username}</0>…"

#. placeholder {0}: typeof MUTE_DURATIONS_LABELS[duration] === 'function' ? MUTE_DURATIONS_LABELS[duration]() : _(MUTE_DURATIONS_LABELS[duration])
#: src/components/account-info.jsx:1414
msgid "Muted @{username} for {0}"
msgstr ""

#: src/components/account-info.jsx:1426
msgid "Unable to mute @{username}"
msgstr ""

#: src/components/account-info.jsx:1447
msgid "Remove <0>@{username}</0> from followers?"
msgstr "Odstranit <0>@{username}</0> ze sledujících?"

#: src/components/account-info.jsx:1467
msgid "@{username} removed from followers"
msgstr ""

#: src/components/account-info.jsx:1479
msgid "Remove follower…"
msgstr "Odstranit sledujícího…"

#: src/components/account-info.jsx:1490
msgid "Block <0>@{username}</0>?"
msgstr "Blokovat <0>@{username}</0>?"

#: src/components/account-info.jsx:1514
msgid "Unblocked @{username}"
msgstr ""

#: src/components/account-info.jsx:1522
msgid "Blocked @{username}"
msgstr ""

#: src/components/account-info.jsx:1530
msgid "Unable to unblock @{username}"
msgstr ""

#: src/components/account-info.jsx:1532
msgid "Unable to block @{username}"
msgstr ""

#: src/components/account-info.jsx:1542
msgid "Unblock <0>@{username}</0>"
msgstr "Odblokovat <0>@{username}</0>"

#: src/components/account-info.jsx:1551
msgid "Block <0>@{username}</0>…"
msgstr "Blok <0>@{username}</0>…"

#: src/components/account-info.jsx:1568
msgid "Report <0>@{username}</0>…"
msgstr "Nahlásit <0>@{username}</0>…"

#: src/components/account-info.jsx:1588
#: src/components/account-info.jsx:2103
msgid "Edit profile"
msgstr "Upravit profil"

#: src/components/account-info.jsx:1624
msgid "Withdraw follow request?"
msgstr ""

#. placeholder {1}: info.acct || info.username
#: src/components/account-info.jsx:1625
msgid "Unfollow @{1}?"
msgstr ""

#: src/components/account-info.jsx:1676
msgid "Unfollow…"
msgstr "Přestat sledovat…"

#: src/components/account-info.jsx:1685
msgid "Withdraw…"
msgstr "Vybrat…"

#: src/components/account-info.jsx:1692
#: src/components/account-info.jsx:1696
#: src/pages/hashtag.jsx:262
msgid "Follow"
msgstr "Sledovat"

#: src/components/account-info.jsx:1808
#: src/components/account-info.jsx:1863
#: src/components/account-info.jsx:1997
#: src/components/account-info.jsx:2098
#: src/components/account-sheet.jsx:38
#: src/components/compose.jsx:859
#: src/components/compose.jsx:2548
#: src/components/compose.jsx:3022
#: src/components/compose.jsx:3231
#: src/components/compose.jsx:3461
#: src/components/drafts.jsx:59
#: src/components/embed-modal.jsx:13
#: src/components/generic-accounts.jsx:143
#: src/components/keyboard-shortcuts-help.jsx:40
#: src/components/list-add-edit.jsx:36
#: src/components/media-alt-modal.jsx:34
#: src/components/media-modal.jsx:322
#: src/components/notification-service.jsx:157
#: src/components/report-modal.jsx:75
#: src/components/shortcuts-settings.jsx:230
#: src/components/shortcuts-settings.jsx:583
#: src/components/shortcuts-settings.jsx:783
#: src/components/status.jsx:2993
#: src/components/status.jsx:3233
#: src/components/status.jsx:3733
#: src/pages/accounts.jsx:37
#: src/pages/catchup.jsx:1581
#: src/pages/filters.jsx:224
#: src/pages/list.jsx:276
#: src/pages/notifications.jsx:915
#: src/pages/settings.jsx:78
#: src/pages/status.jsx:1301
msgid "Close"
msgstr "Zavřít"

#: src/components/account-info.jsx:1813
msgid "Translated Bio"
msgstr "Přeložit bio"

#: src/components/account-info.jsx:1908
msgid "Unable to remove from list."
msgstr ""

#: src/components/account-info.jsx:1909
msgid "Unable to add to list."
msgstr ""

#: src/components/account-info.jsx:1928
#: src/pages/lists.jsx:105
msgid "Unable to load lists."
msgstr "Nelze načíst seznamy."

#: src/components/account-info.jsx:1932
msgid "No lists."
msgstr "Žádné seznamy."

#: src/components/account-info.jsx:1943
#: src/components/list-add-edit.jsx:40
#: src/pages/lists.jsx:59
msgid "New list"
msgstr "Nový seznam"

#. placeholder {0}: account?.username || account?.acct
#: src/components/account-info.jsx:2002
msgid "Private note about <0>@{0}</0>"
msgstr "Soukromá poznámka o <0> @{0}</0>"

#: src/components/account-info.jsx:2032
msgid "Unable to update private note."
msgstr ""

#: src/components/account-info.jsx:2055
#: src/components/account-info.jsx:2226
msgid "Cancel"
msgstr "Zrušit"

#: src/components/account-info.jsx:2060
msgid "Save & close"
msgstr "Uložit a zavřít"

#: src/components/account-info.jsx:2154
msgid "Unable to update profile."
msgstr ""

#: src/components/account-info.jsx:2161
#: src/components/list-add-edit.jsx:105
msgid "Name"
msgstr "Název"

#: src/components/account-info.jsx:2174
msgid "Bio"
msgstr "O mně"

#: src/components/account-info.jsx:2187
msgid "Extra fields"
msgstr "Extra pole"

#: src/components/account-info.jsx:2193
msgid "Label"
msgstr "Štítek"

#: src/components/account-info.jsx:2196
msgid "Content"
msgstr "Obsah"

#: src/components/account-info.jsx:2229
#: src/components/list-add-edit.jsx:150
#: src/components/shortcuts-settings.jsx:715
#: src/pages/filters.jsx:554
#: src/pages/notifications.jsx:981
msgid "Save"
msgstr "Uložit"

#: src/components/account-info.jsx:2283
msgid "username"
msgstr "uživatelské jméno"

#: src/components/account-info.jsx:2287
msgid "server domain name"
msgstr "jméno domény serveru"

#: src/components/background-service.jsx:151
msgid "Cloak mode disabled"
msgstr "Režim zavření zakázán"

#: src/components/background-service.jsx:151
msgid "Cloak mode enabled"
msgstr "Režim skrytí aktivován"

#: src/components/columns.jsx:27
#: src/components/nav-menu.jsx:176
#: src/components/shortcuts-settings.jsx:139
#: src/components/timeline.jsx:439
#: src/pages/catchup.jsx:876
#: src/pages/filters.jsx:89
#: src/pages/followed-hashtags.jsx:41
#: src/pages/home.jsx:53
#: src/pages/notifications.jsx:560
msgid "Home"
msgstr "Domovská stránka"

#: src/components/compose-button.jsx:50
#: src/compose.jsx:38
msgid "Compose"
msgstr "Vytvořit"

#: src/components/compose.jsx:206
msgid "Add media"
msgstr ""

#: src/components/compose.jsx:207
msgid "Add custom emoji"
msgstr "Přidat vlastní emoji"

#: src/components/compose.jsx:208
msgid "Add GIF"
msgstr ""

#: src/components/compose.jsx:209
msgid "Add poll"
msgstr "Přidat anketu"

#: src/components/compose.jsx:402
msgid "You have unsaved changes. Discard this post?"
msgstr "Máte neuložené změny. Zrušit tento příspěvek?"

#. placeholder {0}: unsupportedFiles.length
#. placeholder {1}: unsupportedFiles[0].name
#. placeholder {2}: lf.format( unsupportedFiles.map((f) => f.name), )
#: src/components/compose.jsx:630
msgid "{0, plural, one {File {1} is not supported.} other {Files {2} are not supported.}}"
msgstr ""

#: src/components/compose.jsx:640
#: src/components/compose.jsx:658
#: src/components/compose.jsx:1674
#: src/components/compose.jsx:1760
msgid "{maxMediaAttachments, plural, one {You can only attach up to 1 file.} other {You can only attach up to # files.}}"
msgstr "{maxMediaAttachments, plural, one {Můžete připojit pouze 1 soubor.} few {Můžete připojit pouze # souborů.} many {Můžete připojit pouze # souborů.} other {Můžete připojit pouze # souborů.}}"

#: src/components/compose.jsx:840
msgid "Pop out"
msgstr "Vyskakovací okno"

#: src/components/compose.jsx:847
msgid "Minimize"
msgstr "Minimalizovat"

#: src/components/compose.jsx:883
msgid "Looks like you closed the parent window."
msgstr "Zdá se, že jste zavřeli nadřazené okno."

#: src/components/compose.jsx:890
msgid "Looks like you already have a compose field open in the parent window and currently publishing. Please wait for it to be done and try again later."
msgstr "Vypadá to, že již máte složené pole otevřené v nadřazeném okně a aktuálně publikované. Počkejte prosím, než se to udělá a zkuste to znovu později."

#: src/components/compose.jsx:895
msgid "Looks like you already have a compose field open in the parent window. Popping in this window will discard the changes you made in the parent window. Continue?"
msgstr "Vypadá to, že již máte v nadřazeném okně otevřené políčko. Vyskakování v tomto okně zruší změny, které jste provedli v nadřazeném okně. Pokračovat?"

#: src/components/compose.jsx:937
msgid "Pop in"
msgstr "Ukázat v"

#. placeholder {0}: replyToStatus.account.acct || replyToStatus.account.username
#. placeholder {1}: rtf.format(-replyToStatusMonthsAgo, 'month')
#: src/components/compose.jsx:947
msgid "Replying to @{0}’s post (<0>{1}</0>)"
msgstr "Odpovědět na příspěvek od @{0} (<0>{1}</0>)"

#. placeholder {0}: replyToStatus.account.acct || replyToStatus.account.username
#: src/components/compose.jsx:957
msgid "Replying to @{0}’s post"
msgstr "Odpovídám na příspěvek uživatele @{0}"

#: src/components/compose.jsx:970
msgid "Editing source post"
msgstr "Editace zdrojového příspěvku"

#: src/components/compose.jsx:1017
msgid "Poll must have at least 2 options"
msgstr "Anketa musí mít alespoň dvě možnosti"

#: src/components/compose.jsx:1021
msgid "Some poll choices are empty"
msgstr "Některé volby anket jsou prázdné"

#: src/components/compose.jsx:1034
msgid "Some media have no descriptions. Continue?"
msgstr "Některá média jsou bez popisu. Pokračovat?"

#: src/components/compose.jsx:1086
msgid "Attachment #{i} failed"
msgstr "Příloha #{i} selhala"

#: src/components/compose.jsx:1180
#: src/components/status.jsx:2063
#: src/components/timeline.jsx:989
msgid "Content warning"
msgstr "Varování o obsahu"

#: src/components/compose.jsx:1196
msgid "Content warning or sensitive media"
msgstr "Upozornění na obsah nebo citlivá média"

#: src/components/compose.jsx:1232
#: src/components/status.jsx:93
#: src/pages/settings.jsx:306
msgid "Public"
msgstr "Veřejný"

#: src/components/compose.jsx:1237
#: src/components/nav-menu.jsx:338
#: src/components/shortcuts-settings.jsx:165
#: src/components/status.jsx:94
msgid "Local"
msgstr "Místní"

#: src/components/compose.jsx:1241
#: src/components/status.jsx:95
#: src/pages/settings.jsx:309
msgid "Unlisted"
msgstr "Neveřejný"

#: src/components/compose.jsx:1244
#: src/components/status.jsx:96
#: src/pages/settings.jsx:312
msgid "Followers only"
msgstr "Pouze pro sledující"

#: src/components/compose.jsx:1247
#: src/components/status.jsx:97
#: src/components/status.jsx:1941
msgid "Private mention"
msgstr "Soukromá zmínka"

#: src/components/compose.jsx:1256
msgid "Post your reply"
msgstr "Poslat odpověď"

#: src/components/compose.jsx:1258
msgid "Edit your post"
msgstr "Upravit příspěvek"

#: src/components/compose.jsx:1259
msgid "What are you doing?"
msgstr "Co děláte??"

#: src/components/compose.jsx:1337
msgid "Mark media as sensitive"
msgstr "Označit média jako citlivá"

#: src/components/compose.jsx:1381
#: src/components/compose.jsx:3080
#: src/components/shortcuts-settings.jsx:715
#: src/pages/list.jsx:362
msgid "Add"
msgstr "Přidat"

#: src/components/compose.jsx:1555
#: src/components/keyboard-shortcuts-help.jsx:152
#: src/components/status.jsx:929
#: src/components/status.jsx:1717
#: src/components/status.jsx:1718
#: src/components/status.jsx:2386
msgid "Reply"
msgstr "Odpovědět"

#: src/components/compose.jsx:1557
msgid "Update"
msgstr "Aktualizovat"

#: src/components/compose.jsx:1558
msgctxt "Submit button in composer"
msgid "Post"
msgstr "Příspěvek"

#: src/components/compose.jsx:1686
msgid "Downloading GIF…"
msgstr "Stahování GIFu…"

#: src/components/compose.jsx:1714
msgid "Failed to download GIF"
msgstr "Nepodařilo se stáhnout GIF"

#: src/components/compose.jsx:1879
#: src/components/compose.jsx:1956
#: src/components/nav-menu.jsx:239
msgid "More…"
msgstr "Více…"

#: src/components/compose.jsx:2361
msgid "Uploaded"
msgstr "Odesláno"

#: src/components/compose.jsx:2374
msgid "Image description"
msgstr "Popis obrázku"

#: src/components/compose.jsx:2375
msgid "Video description"
msgstr "Popis videa"

#: src/components/compose.jsx:2376
msgid "Audio description"
msgstr "Popis audia"

#. placeholder {0}: prettyBytes( imageSize, )
#. placeholder {1}: prettyBytes(imageSizeLimit)
#: src/components/compose.jsx:2412
msgid "File size too large. Uploading might encounter issues. Try reduce the file size from {0} to {1} or lower."
msgstr "Velikost souboru je příliš velká. Při nahrávání mohou vzniknout problémy. Zkuste zmenšit velikost souboru z {0} na {1} nebo nižší."

#. placeholder {2}: i18n.number( width, )
#. placeholder {3}: i18n.number(height)
#. placeholder {4}: i18n.number(newWidth)
#. placeholder {5}: i18n.number( newHeight, )
#: src/components/compose.jsx:2424
msgid "Dimension too large. Uploading might encounter issues. Try reduce dimension from {2}×{3}px to {4}×{5}px."
msgstr ""

#. placeholder {6}: prettyBytes( videoSize, )
#. placeholder {7}: prettyBytes(videoSizeLimit)
#: src/components/compose.jsx:2432
msgid "File size too large. Uploading might encounter issues. Try reduce the file size from {6} to {7} or lower."
msgstr ""

#. placeholder {8}: i18n.number( width, )
#. placeholder {9}: i18n.number(height)
#. placeholder {10}: i18n.number(newWidth)
#. placeholder {11}: i18n.number( newHeight, )
#: src/components/compose.jsx:2444
msgid "Dimension too large. Uploading might encounter issues. Try reduce dimension from {8}×{9}px to {10}×{11}px."
msgstr ""

#: src/components/compose.jsx:2452
msgid "Frame rate too high. Uploading might encounter issues."
msgstr "Snímková frekvence je příliš vysoká. Při nahrávání mohou vzniknout problémy."

#: src/components/compose.jsx:2512
#: src/components/compose.jsx:2762
#: src/components/shortcuts-settings.jsx:726
#: src/pages/catchup.jsx:1074
#: src/pages/filters.jsx:412
msgid "Remove"
msgstr "Odstranit"

#: src/components/compose.jsx:2529
#: src/compose.jsx:84
msgid "Error"
msgstr "Chyba"

#: src/components/compose.jsx:2554
msgid "Edit image description"
msgstr "Upravit popis obrázku"

#: src/components/compose.jsx:2555
msgid "Edit video description"
msgstr "Upravit popis videa"

#: src/components/compose.jsx:2556
msgid "Edit audio description"
msgstr "Upravit popis audia"

#: src/components/compose.jsx:2601
#: src/components/compose.jsx:2650
msgid "Generating description. Please wait…"
msgstr "Generování popisu. Počkejte prosím…"

#. placeholder {12}: e.message
#: src/components/compose.jsx:2621
msgid "Failed to generate description: {12}"
msgstr ""

#: src/components/compose.jsx:2622
msgid "Failed to generate description"
msgstr "Nepodařilo se vytvořit popis"

#: src/components/compose.jsx:2634
#: src/components/compose.jsx:2640
#: src/components/compose.jsx:2686
msgid "Generate description…"
msgstr "Vytvořit popis…"

#. placeholder {13}: e?.message ? `: ${e.message}` : ''
#: src/components/compose.jsx:2673
msgid "Failed to generate description{13}"
msgstr ""

#. placeholder {0}: localeCode2Text(lang)
#: src/components/compose.jsx:2688
msgid "({0}) <0>— experimental</0>"
msgstr "({0}) <0>– experimentální</0>"

#: src/components/compose.jsx:2707
msgid "Done"
msgstr "Hotovo"

#. placeholder {0}: i + 1
#: src/components/compose.jsx:2743
msgid "Choice {0}"
msgstr ""

#: src/components/compose.jsx:2790
msgid "Multiple choices"
msgstr "Více možností"

#: src/components/compose.jsx:2793
msgid "Duration"
msgstr "Trvání"

#: src/components/compose.jsx:2824
msgid "Remove poll"
msgstr "Odstranit anketu"

#: src/components/compose.jsx:3039
msgid "Search accounts"
msgstr ""

#: src/components/compose.jsx:3093
#: src/components/generic-accounts.jsx:228
msgid "Error loading accounts"
msgstr "Chyba při načítání účtů"

#: src/components/compose.jsx:3237
msgid "Custom emojis"
msgstr "Vlastní emoji"

#: src/components/compose.jsx:3257
msgid "Search emoji"
msgstr ""

#: src/components/compose.jsx:3288
msgid "Error loading custom emojis"
msgstr "Chyba při načítání vlastních emoji"

#: src/components/compose.jsx:3299
msgid "Recently used"
msgstr ""

#: src/components/compose.jsx:3300
msgid "Others"
msgstr ""

#. placeholder {0}: i18n.number(emojis.length - max)
#: src/components/compose.jsx:3338
msgid "{0} more…"
msgstr "{0} další…"

#: src/components/compose.jsx:3476
msgid "Search GIFs"
msgstr ""

#: src/components/compose.jsx:3491
msgid "Powered by GIPHY"
msgstr ""

#: src/components/compose.jsx:3499
msgid "Type to search GIFs"
msgstr "Zadejte pro vyhledávání GIFů"

#: src/components/compose.jsx:3597
#: src/components/media-modal.jsx:462
#: src/components/timeline.jsx:893
msgid "Previous"
msgstr "Zpět"

#: src/components/compose.jsx:3615
#: src/components/media-modal.jsx:481
#: src/components/timeline.jsx:910
msgid "Next"
msgstr "Další"

#: src/components/compose.jsx:3632
msgid "Error loading GIFs"
msgstr "Chyba při načítání GIFů"

#: src/components/drafts.jsx:64
#: src/pages/settings.jsx:693
msgid "Unsent drafts"
msgstr "Neodeslané koncepty"

#: src/components/drafts.jsx:69
msgid "Looks like you have unsent drafts. Let's continue where you left off."
msgstr "Vypadá to, že máte neodeslané koncepty. Pojďme pokračovat tam, kde jste skončili."

#: src/components/drafts.jsx:103
msgid "Delete this draft?"
msgstr "Smazat koncept?"

#: src/components/drafts.jsx:118
msgid "Error deleting draft! Please try again."
msgstr "Chyba při mazání konceptu. Zkuste to prosím znovu."

#: src/components/drafts.jsx:128
#: src/components/list-add-edit.jsx:186
#: src/components/status.jsx:1352
#: src/pages/filters.jsx:587
msgid "Delete…"
msgstr "Smazat…"

#: src/components/drafts.jsx:147
msgid "Error fetching reply-to status!"
msgstr "Chyba při načítání stavu odpovědi!"

#: src/components/drafts.jsx:172
msgid "Delete all drafts?"
msgstr "Smazat všechny koncepty?"

#: src/components/drafts.jsx:190
msgid "Error deleting drafts! Please try again."
msgstr "Chyba při mazání konceptů! Zkuste to prosím znovu."

#: src/components/drafts.jsx:202
msgid "Delete all…"
msgstr "Smazat vše…"

#: src/components/drafts.jsx:210
msgid "No drafts found."
msgstr "Nebyly nalezeny žádné koncepty."

#: src/components/drafts.jsx:247
#: src/pages/catchup.jsx:1929
msgid "Poll"
msgstr "Anketa"

#: src/components/drafts.jsx:250
#: src/pages/account-statuses.jsx:364
msgid "Media"
msgstr "Média"

#: src/components/embed-modal.jsx:23
msgid "Open in new window"
msgstr "Otevřít v novém okně"

#: src/components/follow-request-buttons.jsx:43
#: src/pages/notifications.jsx:965
msgid "Accept"
msgstr "Přijmout"

#: src/components/follow-request-buttons.jsx:69
msgid "Reject"
msgstr "Odmítnout"

#: src/components/follow-request-buttons.jsx:76
#: src/pages/notifications.jsx:1249
msgid "Accepted"
msgstr "Přijato"

#: src/components/follow-request-buttons.jsx:80
msgid "Rejected"
msgstr "Odmítnuto"

#: src/components/generic-accounts.jsx:146
#: src/components/notification.jsx:445
#: src/pages/accounts.jsx:42
#: src/pages/search.jsx:318
#: src/pages/search.jsx:351
msgid "Accounts"
msgstr "Účty"

#: src/components/generic-accounts.jsx:206
#: src/components/timeline.jsx:521
#: src/pages/list.jsx:295
#: src/pages/notifications.jsx:895
#: src/pages/search.jsx:545
#: src/pages/status.jsx:1334
msgid "Show more…"
msgstr "Zobrazit více…"

#: src/components/generic-accounts.jsx:211
#: src/components/timeline.jsx:526
#: src/pages/search.jsx:550
msgid "The end."
msgstr "Konec."

#: src/components/generic-accounts.jsx:232
msgid "Nothing to show"
msgstr "Nic k zobrazení"

#: src/components/keyboard-shortcuts-help.jsx:44
#: src/components/nav-menu.jsx:357
#: src/pages/catchup.jsx:1619
msgid "Keyboard shortcuts"
msgstr "Klávesové zkratky"

#: src/components/keyboard-shortcuts-help.jsx:52
msgid "Keyboard shortcuts help"
msgstr "Nápověda pro klávesové zkratky"

#: src/components/keyboard-shortcuts-help.jsx:56
#: src/pages/catchup.jsx:1644
msgid "Next post"
msgstr "Následující příspěvek"

#: src/components/keyboard-shortcuts-help.jsx:60
#: src/pages/catchup.jsx:1652
msgid "Previous post"
msgstr "Předchozí příspěvek"

#: src/components/keyboard-shortcuts-help.jsx:64
msgid "Skip carousel to next post"
msgstr "Přeskočit carousel na další příspěvek"

#: src/components/keyboard-shortcuts-help.jsx:66
msgid "<0>Shift</0> + <1>j</1>"
msgstr "<0>Shift</0>+ <1>j</1>"

#: src/components/keyboard-shortcuts-help.jsx:72
msgid "Skip carousel to previous post"
msgstr "Přeskočit na předchozí příspěvek v karuselu"

#: src/components/keyboard-shortcuts-help.jsx:74
msgid "<0>Shift</0> + <1>k</1>"
msgstr "<0>Shift</0>+ <1>j</1>"

#: src/components/keyboard-shortcuts-help.jsx:80
msgid "Load new posts"
msgstr "Načíst nové příspěvky"

#: src/components/keyboard-shortcuts-help.jsx:84
#: src/pages/catchup.jsx:1676
msgid "Open post details"
msgstr "Otevře detaily příspěvku"

#: src/components/keyboard-shortcuts-help.jsx:86
msgid "<0>Enter</0> or <1>o</1>"
msgstr "<0>Enter</0> nebo <1>o </1>"

#: src/components/keyboard-shortcuts-help.jsx:93
msgid "Expand content warning or<0/>toggle expanded/collapsed thread"
msgstr "Rozbalit varování obsahu nebo<0/>přepínat rozšířené nebo sbalené vlákno"

#: src/components/keyboard-shortcuts-help.jsx:102
msgid "Close post or dialogs"
msgstr "Zavřít příspěvek nebo dialogové okno"

#: src/components/keyboard-shortcuts-help.jsx:104
msgid "<0>Esc</0> or <1>Backspace</1>"
msgstr "<0>Esc</0> nebo <1>Backspace</1>"

#: src/components/keyboard-shortcuts-help.jsx:110
msgid "Focus column in multi-column mode"
msgstr "Zaměřit se na sloupec v režimu více sloupců"

#: src/components/keyboard-shortcuts-help.jsx:112
msgid "<0>1</0> to <1>9</1>"
msgstr "<0>1</0> do <1>9</1>"

#: src/components/keyboard-shortcuts-help.jsx:118
msgid "Focus next column in multi-column mode"
msgstr ""

#: src/components/keyboard-shortcuts-help.jsx:122
msgid "Focus previous column in multi-column mode"
msgstr ""

#: src/components/keyboard-shortcuts-help.jsx:126
msgid "Compose new post"
msgstr "Napsat nový příspěvek"

#: src/components/keyboard-shortcuts-help.jsx:130
msgid "Compose new post (new window)"
msgstr "Napsat nový příspěvek (nové okno)"

#: src/components/keyboard-shortcuts-help.jsx:133
msgid "<0>Shift</0> + <1>c</1>"
msgstr "<0>Shift</0> + <1>c</1>"

#: src/components/keyboard-shortcuts-help.jsx:139
msgid "Send post"
msgstr "Odeslat příspěvek"

#: src/components/keyboard-shortcuts-help.jsx:141
msgid "<0>Ctrl</0> + <1>Enter</1> or <2>⌘</2> + <3>Enter</3>"
msgstr "<0>Ctrl</0> + <1>Enter</1> or <2>⌘</2> + <3>Enter</3>"

#: src/components/keyboard-shortcuts-help.jsx:148
#: src/components/nav-menu.jsx:326
#: src/components/search-form.jsx:73
#: src/components/shortcuts-settings.jsx:52
#: src/components/shortcuts-settings.jsx:179
#: src/pages/search.jsx:46
#: src/pages/search.jsx:300
msgid "Search"
msgstr "Hledat"

#: src/components/keyboard-shortcuts-help.jsx:156
msgid "Reply (new window)"
msgstr "Odpovědět (nové okno)"

#: src/components/keyboard-shortcuts-help.jsx:159
msgid "<0>Shift</0> + <1>r</1>"
msgstr "<0>Shift</0> + <1>r</1>"

#: src/components/keyboard-shortcuts-help.jsx:165
msgid "Like (favourite)"
msgstr "Líbí se mi (oblíbené)"

#: src/components/keyboard-shortcuts-help.jsx:167
msgid "<0>l</0> or <1>f</1>"
msgstr "<0>l</0> nebo <1>f</1>"

#: src/components/keyboard-shortcuts-help.jsx:173
#: src/components/status.jsx:937
#: src/components/status.jsx:2413
#: src/components/status.jsx:2444
#: src/components/status.jsx:2445
msgid "Boost"
msgstr "Boost"

#: src/components/keyboard-shortcuts-help.jsx:175
msgid "<0>Shift</0> + <1>b</1>"
msgstr "<0>Shift</0> + <1>b</1>"

#: src/components/keyboard-shortcuts-help.jsx:181
#: src/components/status.jsx:1022
#: src/components/status.jsx:2469
#: src/components/status.jsx:2470
msgid "Bookmark"
msgstr "Oblíbené položky"

#: src/components/keyboard-shortcuts-help.jsx:185
msgid "Toggle Cloak mode"
msgstr "Přepnout režim maskování"

#: src/components/keyboard-shortcuts-help.jsx:187
msgid "<0>Shift</0> + <1>Alt</1> + <2>k</2>"
msgstr "<0>Shift</0> + <1>Alt</1> + <2>k</2>"

#: src/components/list-add-edit.jsx:40
msgid "Edit list"
msgstr "Upravit seznam"

#: src/components/list-add-edit.jsx:96
msgid "Unable to edit list."
msgstr "Seznam nelze upravit."

#: src/components/list-add-edit.jsx:97
msgid "Unable to create list."
msgstr "Seznam nelze vytvořit."

#: src/components/list-add-edit.jsx:125
msgid "Show replies to list members"
msgstr "Zobrazit odpovědi členům seznamu"

#: src/components/list-add-edit.jsx:128
msgid "Show replies to people I follow"
msgstr "Zobrazit odpovědi lidem, které sleduji"

#: src/components/list-add-edit.jsx:131
msgid "Don't show replies"
msgstr "Nezobrazovat odpovědi"

#: src/components/list-add-edit.jsx:144
msgid "Hide posts on this list from Home/Following"
msgstr "Skrýt příspěvky z tohoto seznamu na Domovské stránce/Sledované"

#: src/components/list-add-edit.jsx:150
#: src/pages/filters.jsx:554
msgid "Create"
msgstr "Vytvořit"

#: src/components/list-add-edit.jsx:157
msgid "Delete this list?"
msgstr "Smazat tento seznam?"

#: src/components/list-add-edit.jsx:176
msgid "Unable to delete list."
msgstr "Seznam nelze smazat."

#: src/components/media-alt-modal.jsx:39
#: src/components/media.jsx:51
msgid "Media description"
msgstr "Popis médií"

#: src/components/media-alt-modal.jsx:58
#: src/components/status.jsx:1066
#: src/components/status.jsx:1093
#: src/components/translation-block.jsx:196
msgid "Translate"
msgstr "Přeložit"

#: src/components/media-alt-modal.jsx:69
#: src/components/status.jsx:1080
#: src/components/status.jsx:1107
msgid "Speak"
msgstr "Přečíst"

#: src/components/media-modal.jsx:369
msgid "Open original media in new window"
msgstr "Otevřít originální média v novém okně"

#: src/components/media-modal.jsx:373
msgid "Open original media"
msgstr "Otevřít původní média"

#: src/components/media-modal.jsx:389
msgid "Attempting to describe image. Please wait…"
msgstr "Pokus o popis obrázku. Počkejte prosím,…"

#: src/components/media-modal.jsx:404
msgid "Failed to describe image"
msgstr "Nepodařilo se popsat obrázek"

#: src/components/media-modal.jsx:414
msgid "Describe image…"
msgstr "Popište obrázek…"

#: src/components/media-modal.jsx:437
msgid "View post"
msgstr "Zobrazit příspěvek"

#: src/components/media-post.jsx:128
msgid "Sensitive media"
msgstr "Citlivá média"

#: src/components/media-post.jsx:133
msgid "Filtered: {filterTitleStr}"
msgstr "Filtrováno: {filterTitleStr}"

#: src/components/media-post.jsx:134
#: src/components/status.jsx:3563
#: src/components/status.jsx:3659
#: src/components/status.jsx:3737
#: src/components/timeline.jsx:978
#: src/pages/catchup.jsx:75
#: src/pages/catchup.jsx:1877
msgid "Filtered"
msgstr "Filtrovaný"

#: src/components/modals.jsx:73
msgid "Post published. Check it out."
msgstr "Příspěvek zveřejněn. Podívejte se na něj."

#: src/components/modals.jsx:74
msgid "Reply posted. Check it out."
msgstr "Odpověď odeslána. Podívejte se na ni."

#: src/components/modals.jsx:75
msgid "Post updated. Check it out."
msgstr "Příspěvek aktualizován. Podívejte se na něj."

#: src/components/nav-menu.jsx:118
msgid "Menu"
msgstr "Menu"

#: src/components/nav-menu.jsx:154
msgid "Reload page now to update?"
msgstr "Znovu načíst stránku a aktualizovat?"

#: src/components/nav-menu.jsx:166
msgid "New update available…"
msgstr "Nová aktualizace k dispozici…"

#. js-lingui-explicit-id
#: src/components/nav-menu.jsx:185
#: src/components/shortcuts-settings.jsx:140
#: src/pages/following.jsx:23
#: src/pages/following.jsx:142
msgid "following.title"
msgstr ""

#: src/components/nav-menu.jsx:192
#: src/pages/catchup.jsx:871
msgid "Catch-up"
msgstr "Rekapitulace"

#: src/components/nav-menu.jsx:199
#: src/components/shortcuts-settings.jsx:58
#: src/components/shortcuts-settings.jsx:146
#: src/pages/home.jsx:225
#: src/pages/mentions.jsx:21
#: src/pages/mentions.jsx:168
#: src/pages/settings.jsx:1147
#: src/pages/trending.jsx:382
msgid "Mentions"
msgstr "Zmínky"

#: src/components/nav-menu.jsx:206
#: src/components/shortcuts-settings.jsx:49
#: src/components/shortcuts-settings.jsx:152
#: src/pages/filters.jsx:23
#: src/pages/home.jsx:85
#: src/pages/home.jsx:185
#: src/pages/notifications.jsx:113
#: src/pages/notifications.jsx:564
msgid "Notifications"
msgstr "Oznámení"

#: src/components/nav-menu.jsx:209
msgid "New"
msgstr "Nový"

#: src/components/nav-menu.jsx:220
msgid "Profile"
msgstr "Profil"

#: src/components/nav-menu.jsx:228
#: src/components/shortcuts-settings.jsx:54
#: src/components/shortcuts-settings.jsx:195
#: src/pages/bookmarks.jsx:12
#: src/pages/bookmarks.jsx:24
msgid "Bookmarks"
msgstr "Záložky"

#: src/components/nav-menu.jsx:248
#: src/components/shortcuts-settings.jsx:55
#: src/components/shortcuts-settings.jsx:201
#: src/pages/catchup.jsx:1446
#: src/pages/catchup.jsx:2064
#: src/pages/favourites.jsx:12
#: src/pages/favourites.jsx:24
#: src/pages/settings.jsx:1151
msgid "Likes"
msgstr "Líbí se mi"

#: src/components/nav-menu.jsx:254
#: src/pages/followed-hashtags.jsx:15
#: src/pages/followed-hashtags.jsx:45
msgid "Followed Hashtags"
msgstr "Sledované hashtagy"

#: src/components/nav-menu.jsx:262
#: src/pages/account-statuses.jsx:330
#: src/pages/filters.jsx:54
#: src/pages/filters.jsx:93
#: src/pages/hashtag.jsx:340
msgid "Filters"
msgstr "Filtry"

#: src/components/nav-menu.jsx:270
msgid "Muted users"
msgstr "Ztlumení uživatelé"

#: src/components/nav-menu.jsx:278
msgid "Muted users…"
msgstr "Ztlumeni uživatelé…"

#: src/components/nav-menu.jsx:285
msgid "Blocked users"
msgstr "Blokovaní uživatelé"

#: src/components/nav-menu.jsx:293
msgid "Blocked users…"
msgstr "Blokovaní uživatelé…"

#: src/components/nav-menu.jsx:305
msgid "Accounts…"
msgstr "Účty…"

#: src/components/nav-menu.jsx:315
#: src/pages/login.jsx:190
#: src/pages/status.jsx:837
#: src/pages/welcome.jsx:65
msgid "Log in"
msgstr "Přihlásit se"

#: src/components/nav-menu.jsx:332
#: src/components/shortcuts-settings.jsx:57
#: src/components/shortcuts-settings.jsx:172
#: src/pages/trending.jsx:442
msgid "Trending"
msgstr "Trendy"

#: src/components/nav-menu.jsx:344
#: src/components/shortcuts-settings.jsx:165
msgid "Federated"
msgstr "Federovaná"

#: src/components/nav-menu.jsx:367
msgid "Shortcuts / Columns…"
msgstr "Zkratky / Sloupce…"

#: src/components/nav-menu.jsx:377
#: src/components/nav-menu.jsx:391
msgid "Settings…"
msgstr "Nastavení…"

#: src/components/nav-menu.jsx:421
#: src/components/nav-menu.jsx:448
#: src/components/shortcuts-settings.jsx:50
#: src/components/shortcuts-settings.jsx:158
#: src/pages/list.jsx:127
#: src/pages/lists.jsx:17
#: src/pages/lists.jsx:51
msgid "Lists"
msgstr "Seznam"

#: src/components/nav-menu.jsx:429
#: src/components/shortcuts.jsx:215
#: src/pages/list.jsx:134
msgid "All Lists"
msgstr "Všechny seznamy"

#: src/components/notification-service.jsx:161
msgid "Notification"
msgstr "Oznámení"

#: src/components/notification-service.jsx:167
msgid "This notification is from your other account."
msgstr "Toto oznámení pochází z vašeho dalšího účtu."

#: src/components/notification-service.jsx:196
msgid "View all notifications"
msgstr "Zobrazit všechna oznámení"

#: src/components/notification.jsx:71
msgid "{account} reacted to your post with {emojiObject}"
msgstr "{account} reagoval na váš příspěvek s {emojiObject}"

#: src/components/notification.jsx:78
msgid "{account} published a post."
msgstr "{account} publikoval příspěvek."

#. placeholder {0}: shortenNumber(count)
#. placeholder {1}: shortenNumber(count)
#: src/components/notification.jsx:86
msgid "{count, plural, =1 {{postsCount, plural, =1 {{postType, select, reply {{account} boosted your reply.} other {{account} boosted your post.}}} other {{account} boosted {postsCount} of your posts.}}} other {{postType, select, reply {<0><1>{0}</1> people</0> boosted your reply.} other {<2><3>{1}</3> people</2> boosted your post.}}}}"
msgstr ""

#. placeholder {0}: shortenNumber(count)
#: src/components/notification.jsx:129
msgid "{count, plural, =1 {{account} followed you.} other {<0><1>{0}</1> people</0> followed you.}}"
msgstr "{count, plural, =1 {{account} vás začal sledovat.} few {<0><1>{0}</1> lidé</0> vás začali sledovat.} other {<0><1>{0}</1> lidí</0> vás začalo sledovat.}}"

#: src/components/notification.jsx:143
msgid "{account} requested to follow you."
msgstr "{account} vás požádal o sledování."

#. placeholder {0}: shortenNumber(count)
#. placeholder {1}: shortenNumber(count)
#: src/components/notification.jsx:152
msgid "{count, plural, =1 {{postsCount, plural, =1 {{postType, select, reply {{account} liked your reply.} other {{account} liked your post.}}} other {{account} liked {postsCount} of your posts.}}} other {{postType, select, reply {<0><1>{0}</1> people</0> liked your reply.} other {<2><3>{1}</3> people</2> liked your post.}}}}"
msgstr ""

#: src/components/notification.jsx:194
msgid "A poll you have voted in or created has ended."
msgstr "Anketa, v níž jste hlasovali nebo byla vytvořena, skončila."

#: src/components/notification.jsx:195
msgid "A poll you have created has ended."
msgstr "Anketa, kterou jste vytvořili, skončila."

#: src/components/notification.jsx:196
msgid "A poll you have voted in has ended."
msgstr "Anketa, ve které jste hlasovali, skončila."

#: src/components/notification.jsx:197
msgid "A post you interacted with has been edited."
msgstr "Příspěvek, na který jste reagovali, byl upraven."

#. placeholder {0}: shortenNumber(count)
#. placeholder {1}: shortenNumber(count)
#: src/components/notification.jsx:205
msgid "{count, plural, =1 {{postsCount, plural, =1 {{postType, select, reply {{account} boosted & liked your reply.} other {{account} boosted & liked your post.}}} other {{account} boosted & liked {postsCount} of your posts.}}} other {{postType, select, reply {<0><1>{0}</1> people</0> boosted & liked your reply.} other {<2><3>{1}</3> people</2> boosted & liked your post.}}}}"
msgstr ""

#: src/components/notification.jsx:247
msgid "{account} signed up."
msgstr "{account} se zaregistroval/a."

#: src/components/notification.jsx:249
msgid "{account} reported {targetAccount}"
msgstr "{account} nahlásil {targetAccount}"

#: src/components/notification.jsx:254
msgid "Lost connections with <0>{name}</0>."
msgstr "Ztraceno spojení s <0>{name}</0>."

#: src/components/notification.jsx:260
msgid "Moderation warning"
msgstr "Upozornění na moderování"

#: src/components/notification.jsx:265
msgid "Your {year} #Wrapstodon is here!"
msgstr ""

#: src/components/notification.jsx:271
msgid "An admin from <0>{from}</0> has suspended <1>{targetName}</1>, which means you can no longer receive updates from them or interact with them."
msgstr "Admin z <0>{from}</0> pozastavil účet <1>{targetName}</1>, což znamená, že už nemůžete přijímat jejich aktualizace ani s nimi komunikovat."

#: src/components/notification.jsx:277
msgid "An admin from <0>{from}</0> has blocked <1>{targetName}</1>. Affected followers: {followersCount}, followings: {followingCount}."
msgstr "Admin z <0>{from}</0> zablokoval <1>{targetName}</1>. Počet ovlivněných sledujících: {followersCount}, sledovaných: {followingCount}."

#: src/components/notification.jsx:283
msgid "You have blocked <0>{targetName}</0>. Removed followers: {followersCount}, followings: {followingCount}."
msgstr "Zablokovali jste <0>{targetName}</0>. Odstranění sledujících: {followersCount}, následující: {followingCount}."

#: src/components/notification.jsx:291
msgid "Your account has received a moderation warning."
msgstr "Váš účet obdržel upozornění na moderování."

#: src/components/notification.jsx:292
msgid "Your account has been disabled."
msgstr "Váš účet je zablokován."

#: src/components/notification.jsx:293
msgid "Some of your posts have been marked as sensitive."
msgstr "Některé z vašich příspěvků byly označeny jako citlivé."

#: src/components/notification.jsx:294
msgid "Some of your posts have been deleted."
msgstr "Některé z vašich příspěvků byly odstraněny."

#: src/components/notification.jsx:295
msgid "Your posts will be marked as sensitive from now on."
msgstr "Vaše příspěvky budou od nynějška označeny jako citlivé."

#: src/components/notification.jsx:296
msgid "Your account has been limited."
msgstr "Váš účet byl omezen."

#: src/components/notification.jsx:297
msgid "Your account has been suspended."
msgstr "Váš účet byl pozastaven."

#: src/components/notification.jsx:372
msgid "[Unknown notification type: {type}]"
msgstr "[Neznámý typ oznámení: {type}]"

#: src/components/notification.jsx:441
#: src/components/status.jsx:1036
#: src/components/status.jsx:1046
msgid "Boosted/Liked by…"
msgstr "Boost/Líbilo se mi…"

#: src/components/notification.jsx:442
msgid "Liked by…"
msgstr "Líbí se…"

#: src/components/notification.jsx:443
msgid "Boosted by…"
msgstr "Boostováno…"

#: src/components/notification.jsx:444
msgid "Followed by…"
msgstr "Sleduje…"

#: src/components/notification.jsx:515
#: src/components/notification.jsx:531
msgid "Learn more <0/>"
msgstr "Další informace <0/>"

#: src/components/notification.jsx:540
msgid "View #Wrapstodon"
msgstr ""

#: src/components/notification.jsx:770
#: src/components/status.jsx:267
msgid "Read more →"
msgstr "Přečti si více →"

#: src/components/poll.jsx:113
msgid "Voted"
msgstr "Hlasoval/a"

#: src/components/poll.jsx:119
msgid "{optionVotesCount, plural, one {# vote} other {# votes}}"
msgstr ""

#: src/components/poll.jsx:139
#: src/components/poll.jsx:222
#: src/components/poll.jsx:226
msgid "Hide results"
msgstr "Skrýt výsledky"

#: src/components/poll.jsx:188
msgid "Vote"
msgstr "Hlasovat"

#: src/components/poll.jsx:208
#: src/components/poll.jsx:210
#: src/pages/status.jsx:1203
#: src/pages/status.jsx:1226
msgid "Refresh"
msgstr "Obnovit"

#: src/components/poll.jsx:222
#: src/components/poll.jsx:226
msgid "Show results"
msgstr "Zobrazit výsledky"

#. placeholder {0}: shortenNumber(votesCount)
#. placeholder {1}: shortenNumber(votesCount)
#: src/components/poll.jsx:231
msgid "{votesCount, plural, one {<0>{0}</0> vote} other {<1>{1}</1> votes}}"
msgstr "{votesCount, plural, one {<0>{0}</0> hlas} few {<1>{1}</1> hlasy} other {<1>{1}</1> hlasů}}"

#. placeholder {0}: shortenNumber(votersCount)
#. placeholder {1}: shortenNumber(votersCount)
#: src/components/poll.jsx:248
msgid "{votersCount, plural, one {<0>{0}</0> voter} other {<1>{1}</1> voters}}"
msgstr "{votersCount, plural, one {<0>{0}</0> volič} few {<1>{1}</1> voliči} other {<1>{1}</1> voličů}}"

#: src/components/poll.jsx:268
msgid "Ended <0/>"
msgstr "Skončilo <0/>"

#: src/components/poll.jsx:272
msgid "Ended"
msgstr "Ukončeno"

#: src/components/poll.jsx:275
msgid "Ending <0/>"
msgstr "Konec <0/>"

#: src/components/poll.jsx:279
msgid "Ending"
msgstr "Ukončení"

#. Relative time in seconds, as short as possible
#. placeholder {0}: seconds < 1 ? 1 : Math.floor(seconds)
#: src/components/relative-time.jsx:57
msgid "{0}s"
msgstr "{0}s"

#. Relative time in minutes, as short as possible
#. placeholder {0}: Math.floor(seconds / minute)
#: src/components/relative-time.jsx:62
msgid "{0}m"
msgstr "{0}m"

#. Relative time in hours, as short as possible
#. placeholder {0}: Math.floor(seconds / hour)
#: src/components/relative-time.jsx:67
msgid "{0}h"
msgstr "{0}h"

#: src/components/report-modal.jsx:29
msgid "Spam"
msgstr "Nevyžádané"

#: src/components/report-modal.jsx:30
msgid "Malicious links, fake engagement, or repetitive replies"
msgstr "Škodlivé odkazy, falešné interakce nebo opakované odpovědi"

#: src/components/report-modal.jsx:33
msgid "Illegal"
msgstr "Nelegální"

#: src/components/report-modal.jsx:34
msgid "Violates the law of your or the server's country"
msgstr "Porušuje zákon vaší nebo země serveru"

#: src/components/report-modal.jsx:37
msgid "Server rule violation"
msgstr "Porušení pravidla serveru"

#: src/components/report-modal.jsx:38
msgid "Breaks specific server rules"
msgstr "Porušuje specifická pravidla serveru"

#: src/components/report-modal.jsx:39
msgid "Violation"
msgstr "Porušení"

#: src/components/report-modal.jsx:42
msgid "Other"
msgstr "Ostatní"

#: src/components/report-modal.jsx:43
msgid "Issue doesn't fit other categories"
msgstr "Problém neodpovídá ostatním kategoriím"

#: src/components/report-modal.jsx:68
msgid "Report Post"
msgstr "Nahlásit příspěvek"

#: src/components/report-modal.jsx:68
msgid "Report @{username}"
msgstr "Nahlásit @{username}"

#: src/components/report-modal.jsx:104
msgid "Pending review"
msgstr "Čeká na posouzení"

#: src/components/report-modal.jsx:146
msgid "Post reported"
msgstr "Příspěvek nahlášen"

#: src/components/report-modal.jsx:146
msgid "Profile reported"
msgstr "Profil nahlášen"

#: src/components/report-modal.jsx:154
msgid "Unable to report post"
msgstr "Nelze nahlásit příspěvek"

#: src/components/report-modal.jsx:155
msgid "Unable to report profile"
msgstr "Profil nelze nahlásit"

#: src/components/report-modal.jsx:163
msgid "What's the issue with this post?"
msgstr "Jaký je s tímto příspěvkem problém?"

#: src/components/report-modal.jsx:164
msgid "What's the issue with this profile?"
msgstr "Jaký je s tímto účtem problém?"

#: src/components/report-modal.jsx:233
msgid "Additional info"
msgstr "Další informace"

#: src/components/report-modal.jsx:256
msgid "Forward to <0>{domain}</0>"
msgstr "Přeposlat na <0>{domain}</0>"

#: src/components/report-modal.jsx:266
msgid "Send Report"
msgstr "Odeslat hlášení"

#: src/components/report-modal.jsx:275
msgid "Muted {username}"
msgstr "Ztlumit {username}"

#: src/components/report-modal.jsx:278
msgid "Unable to mute {username}"
msgstr "Nebylo možné ztlumit {username}"

#: src/components/report-modal.jsx:283
msgid "Send Report <0>+ Mute profile</0>"
msgstr "Odeslat hlášení <0>+ ztlumit profil</0>"

#: src/components/report-modal.jsx:294
msgid "Blocked {username}"
msgstr "Zablokován {username}"

#: src/components/report-modal.jsx:297
msgid "Unable to block {username}"
msgstr "Nelze zablokovat {username}"

#: src/components/report-modal.jsx:302
msgid "Send Report <0>+ Block profile</0>"
msgstr "Odeslat hlášení <0>+ Blokovat profil</0>"

#: src/components/search-form.jsx:203
msgid "{query} <0>‒ accounts, hashtags & posts</0>"
msgstr "{query} <0>‒ účty, hashtagy & příspěvky</0>"

#: src/components/search-form.jsx:216
msgid "Posts with <0>{query}</0>"
msgstr "Příspěvky obsahující <0>{query}</0>"

#. placeholder {0}: query.replace(/^#/, '')
#: src/components/search-form.jsx:228
msgid "Posts tagged with <0>#{0}</0>"
msgstr "Příspěvky označené <0>#{0}</0>"

#: src/components/search-form.jsx:242
msgid "Look up <0>{query}</0>"
msgstr "Vyhledat <0>{query}</0>"

#: src/components/search-form.jsx:253
msgid "Accounts with <0>{query}</0>"
msgstr "Účty s <0>{query}</0>"

#: src/components/shortcuts-settings.jsx:48
msgid "Home / Following"
msgstr "Domů / Sledování"

#: src/components/shortcuts-settings.jsx:51
msgid "Public (Local / Federated)"
msgstr "Veřejná (Lokální/Federovaná)"

#: src/components/shortcuts-settings.jsx:53
msgid "Account"
msgstr "Účet"

#: src/components/shortcuts-settings.jsx:56
msgid "Hashtag"
msgstr "Hashtag"

#: src/components/shortcuts-settings.jsx:63
msgid "List ID"
msgstr "ID seznamu"

#: src/components/shortcuts-settings.jsx:70
msgid "Local only"
msgstr "Pouze místní"

#: src/components/shortcuts-settings.jsx:75
#: src/components/shortcuts-settings.jsx:84
#: src/components/shortcuts-settings.jsx:122
#: src/pages/login.jsx:194
msgid "Instance"
msgstr "Instance"

#: src/components/shortcuts-settings.jsx:78
#: src/components/shortcuts-settings.jsx:87
#: src/components/shortcuts-settings.jsx:125
msgid "Optional, e.g. mastodon.social"
msgstr "Nepovinné, např. mastodon.social"

#: src/components/shortcuts-settings.jsx:93
msgid "Search term"
msgstr "Hledaný výraz"

#: src/components/shortcuts-settings.jsx:96
msgid "Optional, unless for multi-column mode"
msgstr "Volitelné, pokud není pro více sloupců"

#: src/components/shortcuts-settings.jsx:113
msgid "e.g. PixelArt (Max 5, space-separated)"
msgstr "např. PixelArt (Max 5, oddělený mezerami)"

#: src/components/shortcuts-settings.jsx:117
#: src/pages/hashtag.jsx:356
msgid "Media only"
msgstr "Pouze média"

#: src/components/shortcuts-settings.jsx:235
#: src/components/shortcuts.jsx:192
msgid "Shortcuts"
msgstr "Zkratky"

#: src/components/shortcuts-settings.jsx:243
msgid "beta"
msgstr "beta"

#: src/components/shortcuts-settings.jsx:249
msgid "Specify a list of shortcuts that'll appear as:"
msgstr "Zadejte seznam zkratek, které se zobrazí jako:"

#: src/components/shortcuts-settings.jsx:255
msgid "Floating button"
msgstr "Plovoucí tlačítko"

#: src/components/shortcuts-settings.jsx:260
msgid "Tab/Menu bar"
msgstr "Záložka/Panel nabídek"

#: src/components/shortcuts-settings.jsx:265
msgid "Multi-column"
msgstr "Více sloupců"

#: src/components/shortcuts-settings.jsx:332
msgid "Not available in current view mode"
msgstr "Není k dispozici v aktuálním režimu zobrazení"

#: src/components/shortcuts-settings.jsx:351
msgid "Move up"
msgstr "Posunout nahoru"

#: src/components/shortcuts-settings.jsx:367
msgid "Move down"
msgstr "Dolů"

#: src/components/shortcuts-settings.jsx:379
#: src/components/status.jsx:1314
#: src/pages/list.jsx:171
msgid "Edit"
msgstr "Upravit"

#: src/components/shortcuts-settings.jsx:400
msgid "Add more than one shortcut/column to make this work."
msgstr "Přidejte více než jednu zkratku/sloupec, aby to fungovalo."

#: src/components/shortcuts-settings.jsx:411
msgid "No columns yet. Tap on the Add column button."
msgstr "Zatím žádné sloupce. Klikněte na tlačítko Přidat sloupec."

#: src/components/shortcuts-settings.jsx:412
msgid "No shortcuts yet. Tap on the Add shortcut button."
msgstr "Zatím žádné zkratky. Klepněte na tlačítko Přidat zkratku."

#: src/components/shortcuts-settings.jsx:415
msgid "Not sure what to add?<0/>Try adding <1>Home / Following and Notifications</1> first."
msgstr "Nejste si jisti, co přidat?<0/>Zkuste nejdříve přidat <1>Domů / Sledování a oznámení</1>."

#: src/components/shortcuts-settings.jsx:443
msgid "Max {SHORTCUTS_LIMIT} columns"
msgstr "Max {SHORTCUTS_LIMIT} sloupců"

#: src/components/shortcuts-settings.jsx:444
msgid "Max {SHORTCUTS_LIMIT} shortcuts"
msgstr "Maximálně {SHORTCUTS_LIMIT} zkratek"

#: src/components/shortcuts-settings.jsx:458
msgid "Import/export"
msgstr "Import/export"

#: src/components/shortcuts-settings.jsx:468
msgid "Add column…"
msgstr "Přidat sloupec…"

#: src/components/shortcuts-settings.jsx:469
msgid "Add shortcut…"
msgstr "Přidat zkratku…"

#: src/components/shortcuts-settings.jsx:516
msgid "Specific list is optional. For multi-column mode, list is required, else the column will not be shown."
msgstr "Specifický seznam je volitelný. Pro režim více sloupců je seznam povinný, jinak se sloupec nezobrazí."

#: src/components/shortcuts-settings.jsx:517
msgid "For multi-column mode, search term is required, else the column will not be shown."
msgstr "Pro režim více sloupců je vyžadován hledaný výraz, jinak nebude sloupec zobrazen."

#: src/components/shortcuts-settings.jsx:518
msgid "Multiple hashtags are supported. Space-separated."
msgstr "Podporováno je více hashtagů. Oddělené mezerami."

#: src/components/shortcuts-settings.jsx:587
msgid "Edit shortcut"
msgstr "Upravit zkratky"

#: src/components/shortcuts-settings.jsx:587
msgid "Add shortcut"
msgstr "Přidat zkratku"

#: src/components/shortcuts-settings.jsx:623
msgid "Timeline"
msgstr "Časová osa"

#: src/components/shortcuts-settings.jsx:649
msgid "List"
msgstr "Seznam"

#: src/components/shortcuts-settings.jsx:788
msgid "Import/Export <0>Shortcuts</0>"
msgstr "Importovat/Exportovat <0>Zástupce</0>"

#: src/components/shortcuts-settings.jsx:798
msgid "Import"
msgstr "Importovat"

#: src/components/shortcuts-settings.jsx:806
msgid "Paste shortcuts here"
msgstr "Zde vložte zkratky"

#: src/components/shortcuts-settings.jsx:822
msgid "Downloading saved shortcuts from instance server…"
msgstr "Stahuji uložené zkratky z instance serveru…"

#: src/components/shortcuts-settings.jsx:851
msgid "Unable to download shortcuts"
msgstr "Zkratky nelze stáhnout"

#: src/components/shortcuts-settings.jsx:854
msgid "Download shortcuts from instance server"
msgstr "Stáhnout zkratky z instance serveru"

#: src/components/shortcuts-settings.jsx:912
msgid "* Exists in current shortcuts"
msgstr "* Existuje v aktuálních zkratkách"

#: src/components/shortcuts-settings.jsx:917
msgid "List may not work if it's from a different account."
msgstr "Seznam nemusí fungovat, pokud je z jiného účtu."

#: src/components/shortcuts-settings.jsx:927
msgid "Invalid settings format"
msgstr "Neplatný formát nastavení"

#: src/components/shortcuts-settings.jsx:935
msgid "Append to current shortcuts?"
msgstr "Existuje v aktuálních zkratkách?"

#: src/components/shortcuts-settings.jsx:938
msgid "Only shortcuts that don’t exist in current shortcuts will be appended."
msgstr "Budou připojeny pouze zkratky, které v současných zkratkách neexistují."

#: src/components/shortcuts-settings.jsx:960
msgid "No new shortcuts to import"
msgstr "Žádné nové zkratky k importu"

#: src/components/shortcuts-settings.jsx:975
msgid "Shortcuts imported. Exceeded max {SHORTCUTS_LIMIT}, so the rest are not imported."
msgstr "Zkratky importovány. Překročeno max. {SHORTCUTS_LIMIT}, zbytek tedy není importován."

#: src/components/shortcuts-settings.jsx:976
#: src/components/shortcuts-settings.jsx:1000
msgid "Shortcuts imported"
msgstr "Zkratky importovány"

#: src/components/shortcuts-settings.jsx:986
msgid "Import & append…"
msgstr "Importovat & připojit…"

#: src/components/shortcuts-settings.jsx:994
msgid "Override current shortcuts?"
msgstr "Přepsat aktuální zkratky?"

#: src/components/shortcuts-settings.jsx:995
msgid "Import shortcuts?"
msgstr "Importovat zkratky?"

#: src/components/shortcuts-settings.jsx:1009
msgid "or override…"
msgstr "nebo přepsat…"

#: src/components/shortcuts-settings.jsx:1009
msgid "Import…"
msgstr "Importovat…"

#: src/components/shortcuts-settings.jsx:1018
msgid "Export"
msgstr "Exportovat"

#: src/components/shortcuts-settings.jsx:1033
msgid "Shortcuts copied"
msgstr "Zkratky zkopírovány"

#: src/components/shortcuts-settings.jsx:1036
msgid "Unable to copy shortcuts"
msgstr "Nelze kopírovat zkratky"

#: src/components/shortcuts-settings.jsx:1050
msgid "Shortcut settings copied"
msgstr "Nastavení zkratky zkopírováno"

#: src/components/shortcuts-settings.jsx:1053
msgid "Unable to copy shortcut settings"
msgstr "Nelze kopírovat nastavení zástupce"

#: src/components/shortcuts-settings.jsx:1083
msgid "Share"
msgstr "Sdílet"

#: src/components/shortcuts-settings.jsx:1122
msgid "Saving shortcuts to instance server…"
msgstr "Ukládání zkratek na instanci serveru…"

#: src/components/shortcuts-settings.jsx:1129
msgid "Shortcuts saved"
msgstr "Zkratky uloženy"

#: src/components/shortcuts-settings.jsx:1134
msgid "Unable to save shortcuts"
msgstr "Zkratky nelze uložit"

#: src/components/shortcuts-settings.jsx:1137
msgid "Sync to instance server"
msgstr "Synchronizujte se serverem instance"

#. placeholder {0}: shortcutsStr.length
#: src/components/shortcuts-settings.jsx:1145
msgid "{0, plural, one {# character} other {# characters}}"
msgstr "{0,plural, one{# znak} few {# znaky} many {# znaků} other{# znaků}}"

#: src/components/shortcuts-settings.jsx:1157
msgid "Raw Shortcuts JSON"
msgstr "Nezpracované zkratky JSON"

#: src/components/shortcuts-settings.jsx:1170
msgid "Import/export settings from/to instance server (Very experimental)"
msgstr "Importovat/exportovat nastavení z/do instance serveru (experimentální)"

#: src/components/status.jsx:538
msgid "<0/> <1>boosted</1>"
msgstr "<0/> <1>boostnul</1>"

#: src/components/status.jsx:637
msgid "Sorry, your current logged-in instance can't interact with this post from another instance."
msgstr "Omlouváme se, vaše aktuální přihlášená instance nemůže komunikovat s tímto příspěvkem z jiné instance."

#. placeholder {0}: username || acct
#: src/components/status.jsx:790
msgid "Unliked @{0}'s post"
msgstr "Nelíbí se @{0}"

#. placeholder {1}: username || acct
#: src/components/status.jsx:791
msgid "Liked @{1}'s post"
msgstr ""

#. placeholder {2}: username || acct
#: src/components/status.jsx:830
msgid "Unbookmarked @{2}'s post"
msgstr ""

#. placeholder {3}: username || acct
#: src/components/status.jsx:831
msgid "Bookmarked @{3}'s post"
msgstr ""

#: src/components/status.jsx:937
#: src/components/status.jsx:999
#: src/components/status.jsx:2413
#: src/components/status.jsx:2444
msgid "Unboost"
msgstr "Zrušit boostnutí"

#: src/components/status.jsx:953
#: src/components/status.jsx:2428
msgid "Quote"
msgstr "Citace"

#: src/components/status.jsx:961
#: src/components/status.jsx:2437
msgid "Some media have no descriptions."
msgstr "Některá média jsou bez popisu."

#. placeholder {0}: rtf.format(-statusMonthsAgo, 'month')
#: src/components/status.jsx:968
msgid "Old post (<0>{0}</0>)"
msgstr "Starý příspěvek (<0>{0}</0>)"

#. placeholder {4}: username || acct
#: src/components/status.jsx:987
msgid "Unboosted @{4}'s post"
msgstr ""

#. placeholder {5}: username || acct
#: src/components/status.jsx:988
msgid "Boosted @{5}'s post"
msgstr ""

#: src/components/status.jsx:1000
msgid "Boost…"
msgstr "Boostnout…"

#: src/components/status.jsx:1012
#: src/components/status.jsx:1727
#: src/components/status.jsx:2457
msgid "Unlike"
msgstr "Nelíbí se mi"

#: src/components/status.jsx:1013
#: src/components/status.jsx:1727
#: src/components/status.jsx:1728
#: src/components/status.jsx:2457
#: src/components/status.jsx:2458
msgid "Like"
msgstr "Líbí se mi"

#: src/components/status.jsx:1022
#: src/components/status.jsx:2469
msgid "Unbookmark"
msgstr "Odebrat záložku"

#. placeholder {0}: username || acct
#: src/components/status.jsx:1130
msgid "View post by <0>@{0}</0>"
msgstr "Zobrazit příspěvek od <0>@{0}</0>"

#: src/components/status.jsx:1151
msgid "Show Edit History"
msgstr "Ukázat historii úprav"

#: src/components/status.jsx:1154
msgid "Edited: {editedDateText}"
msgstr "Upraveno: {editedDateText}"

#: src/components/status.jsx:1221
#: src/components/status.jsx:3238
msgid "Embed post"
msgstr "Vložit příspěvek"

#: src/components/status.jsx:1235
msgid "Conversation unmuted"
msgstr "Ztlumení konverzace zrušeno"

#: src/components/status.jsx:1235
msgid "Conversation muted"
msgstr "Konverzace ztlumena"

#: src/components/status.jsx:1241
msgid "Unable to unmute conversation"
msgstr "Nelze zrušit ztlumení konverzace"

#: src/components/status.jsx:1242
msgid "Unable to mute conversation"
msgstr "Nelze ztlumit konverzaci"

#: src/components/status.jsx:1251
msgid "Unmute conversation"
msgstr "Zrušit ztlumení konverzace"

#: src/components/status.jsx:1258
msgid "Mute conversation"
msgstr "Ztlumit konverzaci"

#: src/components/status.jsx:1274
msgid "Post unpinned from profile"
msgstr "Příspěvek odepnut z profilu"

#: src/components/status.jsx:1275
msgid "Post pinned to profile"
msgstr "Příspěvek připnut na profil"

#: src/components/status.jsx:1280
msgid "Unable to unpin post"
msgstr "Nelze odepnout příspěvek"

#: src/components/status.jsx:1280
msgid "Unable to pin post"
msgstr "Příspěvek nelze připnout"

#: src/components/status.jsx:1289
msgid "Unpin from profile"
msgstr "Odepnout z profilu"

#: src/components/status.jsx:1296
msgid "Pin to profile"
msgstr "Připnout na profil"

#: src/components/status.jsx:1325
msgid "Delete this post?"
msgstr "Smazat tento příspěvek?"

#: src/components/status.jsx:1341
msgid "Post deleted"
msgstr "Příspěvek odstraněn"

#: src/components/status.jsx:1344
msgid "Unable to delete post"
msgstr "Příspěvek nelze odstranit"

#: src/components/status.jsx:1372
msgid "Report post…"
msgstr "Nahlásit příspěvek…"

#. placeholder {6}: username || acct
#: src/components/status.jsx:1442
msgid "Unboosted @{6}'s post"
msgstr ""

#. placeholder {7}: username || acct
#: src/components/status.jsx:1443
msgid "Boosted @{7}'s post"
msgstr ""

#: src/components/status.jsx:1728
#: src/components/status.jsx:1764
#: src/components/status.jsx:2458
msgid "Liked"
msgstr "Líbí se"

#: src/components/status.jsx:1761
#: src/components/status.jsx:2445
msgid "Boosted"
msgstr "Boosty"

#: src/components/status.jsx:1771
#: src/components/status.jsx:2470
msgid "Bookmarked"
msgstr "Záložky"

#: src/components/status.jsx:1775
msgid "Pinned"
msgstr "Připnuto"

#: src/components/status.jsx:1820
#: src/components/status.jsx:2276
msgid "Deleted"
msgstr "Smazat"

#: src/components/status.jsx:1861
msgid "{repliesCount, plural, one {# reply} other {# replies}}"
msgstr "{repliesCount, plural, one {# odpověď} few {# odpovědi} many {# odpovědi} other {# odpovědi}}"

#. placeholder {0}: snapStates.statusThreadNumber[sKey] ? ` ${snapStates.statusThreadNumber[sKey]}/X` : ''
#: src/components/status.jsx:1950
msgid "Thread{0}"
msgstr "Vlákna{0}"

#: src/components/status.jsx:2026
#: src/components/status.jsx:2088
#: src/components/status.jsx:2173
msgid "Show less"
msgstr "Zobrazit méně"

#: src/components/status.jsx:2026
#: src/components/status.jsx:2088
msgid "Show content"
msgstr "Zobrazit obsah"

#: src/components/status.jsx:2173
msgid "Show media"
msgstr "Zobrazit média"

#: src/components/status.jsx:2310
msgid "Edited"
msgstr "Upraveno"

#: src/components/status.jsx:2387
msgid "Comments"
msgstr "Komentáře"

#. More from [Author]
#: src/components/status.jsx:2696
msgid "More from <0/>"
msgstr ""

#: src/components/status.jsx:2998
msgid "Edit History"
msgstr "Historie úprav"

#: src/components/status.jsx:3002
msgid "Failed to load history"
msgstr "Nepodařilo se načíst historii"

#: src/components/status.jsx:3007
#: src/pages/annual-report.jsx:45
msgid "Loading…"
msgstr "Načítání…"

#: src/components/status.jsx:3243
msgid "HTML Code"
msgstr "HTML kód"

#: src/components/status.jsx:3260
msgid "HTML code copied"
msgstr "HTML kód zkopírován"

#: src/components/status.jsx:3263
msgid "Unable to copy HTML code"
msgstr "Nelze kopírovat HTML kód"

#: src/components/status.jsx:3275
msgid "Media attachments:"
msgstr "Přílohy médií:"

#: src/components/status.jsx:3297
msgid "Account Emojis:"
msgstr "Emoji účtu:"

#: src/components/status.jsx:3328
#: src/components/status.jsx:3373
msgid "static URL"
msgstr "statická URL"

#: src/components/status.jsx:3342
msgid "Emojis:"
msgstr "Emoji:"

#: src/components/status.jsx:3387
msgid "Notes:"
msgstr "Poznámky:"

#: src/components/status.jsx:3391
msgid "This is static, unstyled and scriptless. You may need to apply your own styles and edit as needed."
msgstr "Toto je statické, nestylizované a bez skriptů. Možná budete muset použít vlastní styly a podle potřeby upravovat."

#: src/components/status.jsx:3397
msgid "Polls are not interactive, becomes a list with vote counts."
msgstr "Hlasování v anketách není interaktivní, místo toho se zobrazí seznam s počty hlasů."

#: src/components/status.jsx:3402
msgid "Media attachments can be images, videos, audios or any file types."
msgstr "Mediální přílohy mohou být obrázky, videa, audio nebo jakékoli typy souborů."

#: src/components/status.jsx:3408
msgid "Post could be edited or deleted later."
msgstr "Příspěvek může být později upraven nebo odstraněn."

#: src/components/status.jsx:3414
msgid "Preview"
msgstr "Náhled"

#: src/components/status.jsx:3423
msgid "Note: This preview is lightly styled."
msgstr "Poznámka: Tento náhled je lehce stylizovaný."

#. [Name] [Visibility icon] boosted
#: src/components/status.jsx:3667
msgid "<0/> <1/> boosted"
msgstr "<0/><1/> boostnuto"

#: src/components/timeline.jsx:455
#: src/pages/settings.jsx:1175
msgid "New posts"
msgstr "Nové příspěvky"

#: src/components/timeline.jsx:556
#: src/pages/home.jsx:214
#: src/pages/notifications.jsx:871
#: src/pages/status.jsx:990
#: src/pages/status.jsx:1363
msgid "Try again"
msgstr "Zkuste to znovu"

#. placeholder {0}: fItems.length
#: src/components/timeline.jsx:591
msgid "{0, plural, one {# Boost} other {# Boosts}}"
msgstr ""

#: src/components/timeline.jsx:596
msgid "Pinned posts"
msgstr "Připnuté příspěvky"

#: src/components/timeline.jsx:951
#: src/components/timeline.jsx:958
#: src/pages/catchup.jsx:1894
msgid "Thread"
msgstr "Vlákno"

#. placeholder {0}: filterInfo.titlesStr
#: src/components/timeline.jsx:973
msgid "<0>Filtered</0>: <1>{0}</1>"
msgstr "<0>Filtrované</0>: <1>{0}</1>"

#: src/components/translation-block.jsx:153
msgid "Auto-translated from {sourceLangText}"
msgstr "Automaticky přeloženo z {sourceLangText}"

#: src/components/translation-block.jsx:191
msgid "Translating…"
msgstr "Překlad…"

#: src/components/translation-block.jsx:194
msgid "Translate from {sourceLangText} (auto-detected)"
msgstr "Přeložit z {sourceLangText} (detekováno automaticky)"

#: src/components/translation-block.jsx:195
msgid "Translate from {sourceLangText}"
msgstr "Přeložit z {sourceLangText}"

#. placeholder {0}: detectedLang ?? '…'
#: src/components/translation-block.jsx:223
msgid "Auto ({0})"
msgstr "Auto ({0})"

#: src/components/translation-block.jsx:236
msgid "Failed to translate"
msgstr "Překlad se nezdařil"

#: src/compose.jsx:33
msgid "Editing source status"
msgstr ""

#. placeholder {0}: replyToStatus.account?.acct || replyToStatus.account?.username
#: src/compose.jsx:35
msgid "Replying to @{0}"
msgstr "Odpověď @{0}"

#: src/compose.jsx:63
msgid "You may close this page now."
msgstr "Nyní můžete tuto stránku zavřít."

#: src/compose.jsx:71
msgid "Close window"
msgstr "Zavřít okno"

#: src/compose.jsx:87
msgid "Login required."
msgstr "Vyžadováno přihlášení."

#: src/compose.jsx:91
#: src/pages/annual-report.jsx:164
#: src/pages/http-route.jsx:91
#: src/pages/login.jsx:271
msgid "Go home"
msgstr "Domů"

#: src/pages/account-statuses.jsx:232
msgid "Account posts"
msgstr "Příspěvky účtu"

#: src/pages/account-statuses.jsx:239
msgid "{accountDisplay} (+ Replies)"
msgstr "{accountDisplay} (+ Odpovědi)"

#: src/pages/account-statuses.jsx:241
msgid "{accountDisplay} (- Boosts)"
msgstr "{accountDisplay} (- Boosty)"

#: src/pages/account-statuses.jsx:243
msgid "{accountDisplay} (#{tagged})"
msgstr "{accountDisplay} (#{tagged})"

#: src/pages/account-statuses.jsx:245
msgid "{accountDisplay} (Media)"
msgstr "{accountDisplay} (Média)"

#: src/pages/account-statuses.jsx:251
msgid "{accountDisplay} ({monthYear})"
msgstr "{accountDisplay} ({monthYear})"

#: src/pages/account-statuses.jsx:320
msgid "Clear filters"
msgstr "Vymazat filtry"

#: src/pages/account-statuses.jsx:323
msgid "Clear"
msgstr "Vyčistit"

#: src/pages/account-statuses.jsx:337
msgid "Showing post with replies"
msgstr "Zobrazení příspěvku s odpovědmi"

#: src/pages/account-statuses.jsx:342
msgid "+ Replies"
msgstr "+ Odpovědi"

#: src/pages/account-statuses.jsx:348
msgid "Showing posts without boosts"
msgstr "Zobrazení příspěvků bez boostů"

#: src/pages/account-statuses.jsx:353
msgid "- Boosts"
msgstr "- Boosty"

#: src/pages/account-statuses.jsx:359
msgid "Showing posts with media"
msgstr "Zobrazování příspěvků s médii"

#. placeholder {0}: tag.name
#: src/pages/account-statuses.jsx:376
msgid "Showing posts tagged with #{0}"
msgstr "Zobrazuji příspěvky označené štítkem #{0}"

#. placeholder {1}: date.toLocaleString(i18n.locale, { month: 'long', year: 'numeric', })
#: src/pages/account-statuses.jsx:415
msgid "Showing posts in {1}"
msgstr ""

#: src/pages/account-statuses.jsx:504
msgid "Nothing to see here yet."
msgstr "Zatím zde není co vidět."

#: src/pages/account-statuses.jsx:505
#: src/pages/public.jsx:98
#: src/pages/trending.jsx:450
msgid "Unable to load posts"
msgstr "Nelze načíst příspěvky"

#: src/pages/account-statuses.jsx:546
#: src/pages/account-statuses.jsx:576
msgid "Unable to fetch account info"
msgstr "Nelze získat informace o účtu"

#. placeholder {0}: accountInstance ? ( <> {' '} (<b>{punycode.toUnicode(accountInstance)}</b>) </> ) : null
#: src/pages/account-statuses.jsx:553
msgid "Switch to account's instance {0}"
msgstr "Přepnout na instance účtu {0}"

#: src/pages/account-statuses.jsx:583
msgid "Switch to my instance (<0>{currentInstance}</0>)"
msgstr "Přepněte na mou instanci (<0>{currentInstance}</0>)"

#: src/pages/account-statuses.jsx:645
msgid "Month"
msgstr "Měsíc"

#: src/pages/accounts.jsx:56
msgid "Current"
msgstr "Současný"

#: src/pages/accounts.jsx:102
msgid "Default"
msgstr "Výchozí"

#: src/pages/accounts.jsx:124
msgid "Switch to this account"
msgstr "Přepněte na tento účet"

#: src/pages/accounts.jsx:133
msgid "Switch in new tab/window"
msgstr ""

#: src/pages/accounts.jsx:147
msgid "View profile…"
msgstr "Zobrazit profil…"

#: src/pages/accounts.jsx:164
msgid "Set as default"
msgstr "Nastavit jako výchozí"

#. placeholder {0}: account.info.acct
#: src/pages/accounts.jsx:174
msgid "Log out <0>@{0}</0>?"
msgstr "Odhlásit se <0>@{0}</0>?"

#: src/pages/accounts.jsx:197
msgid "Log out…"
msgstr "Odhlásit se…"

#: src/pages/accounts.jsx:210
msgid "Add an existing account"
msgstr "Přidejte existující účet"

#: src/pages/accounts.jsx:217
msgid "Note: <0>Default</0> account will always be used for first load. Switched accounts will persist during the session."
msgstr "Poznámka: <0>Výchozí</0> účet bude vždy použit pro první načtení. Přepnuté účty budou přetrvávat i během relace."

#: src/pages/bookmarks.jsx:26
msgid "No bookmarks yet. Go bookmark something!"
msgstr "Zatím nemáte žádné záložky. Přidejte nějakou!"

#: src/pages/bookmarks.jsx:27
msgid "Unable to load bookmarks."
msgstr "Nelze načíst záložky."

#: src/pages/catchup.jsx:54
msgid "last 1 hour"
msgstr "poslední hodina"

#: src/pages/catchup.jsx:55
msgid "last 2 hours"
msgstr "poslední 2 hodiny"

#: src/pages/catchup.jsx:56
msgid "last 3 hours"
msgstr "poslední 3 hodiny"

#: src/pages/catchup.jsx:57
msgid "last 4 hours"
msgstr "poslední 4 hodiny"

#: src/pages/catchup.jsx:58
msgid "last 5 hours"
msgstr "posledních 5 hodin"

#: src/pages/catchup.jsx:59
msgid "last 6 hours"
msgstr "posledních 6 hodin"

#: src/pages/catchup.jsx:60
msgid "last 7 hours"
msgstr "posledních 7 hodin"

#: src/pages/catchup.jsx:61
msgid "last 8 hours"
msgstr "posledních 8 hodin"

#: src/pages/catchup.jsx:62
msgid "last 9 hours"
msgstr "posledních 9 hodin"

#: src/pages/catchup.jsx:63
msgid "last 10 hours"
msgstr "posledních 10 hodin"

#: src/pages/catchup.jsx:64
msgid "last 11 hours"
msgstr "posledních 11 hodin"

#: src/pages/catchup.jsx:65
msgid "last 12 hours"
msgstr "posledních 12 hodin"

#: src/pages/catchup.jsx:66
msgid "beyond 12 hours"
msgstr "starší než 12 hodin"

#: src/pages/catchup.jsx:73
msgid "Followed tags"
msgstr "Sledované štítky"

#: src/pages/catchup.jsx:74
msgid "Groups"
msgstr "Skupiny"

#: src/pages/catchup.jsx:596
msgid "Showing {selectedFilterCategory, select, all {all posts} original {original posts} replies {replies} boosts {boosts} followedTags {followed tags} groups {groups} filtered {filtered posts}}, {sortBy, select, createdAt {{sortOrder, select, asc {oldest} desc {latest}}} reblogsCount {{sortOrder, select, asc {fewest boosts} desc {most boosts}}} favouritesCount {{sortOrder, select, asc {fewest likes} desc {most likes}}} repliesCount {{sortOrder, select, asc {fewest replies} desc {most replies}}} density {{sortOrder, select, asc {least dense} desc {most dense}}}} first{groupBy, select, account {, grouped by authors} other {}}"
msgstr "Zobrazuji {selectedFilterCategory, select, all {všechny příspěvky} original {původní příspěvky} replies {odpovědi} boosts {bosty} followedTags {sledované štítky} groups {skupiny} filtered {filtrované příspěvky}}, {sortBy, select, createdAt {{sortOrder, select, asc {nejstarší} desc {nejnovější}}} reblogsCount {{sortOrder, select, asc {nejméně bostů} desc {nejvíce bostů}}} favouritesCount {{sortOrder, select, asc {nejméně lajků} desc {nejvíce lajků}}} repliesCount {{sortOrder, select, asc {nejméně odpovědí} desc {nejvíce odpovědí}}} density {{sortOrder, select, asc {nejméně husté} desc {nejhustší}}}} nejprve{groupBy, select, account {, seskupeno podle autorů} other {}}"

#: src/pages/catchup.jsx:882
#: src/pages/catchup.jsx:906
msgid "Catch-up <0>beta</0>"
msgstr "Catch-up <0>beta</0>"

#: src/pages/catchup.jsx:896
#: src/pages/catchup.jsx:1585
msgid "Help"
msgstr "Nápověda"

#: src/pages/catchup.jsx:912
msgid "What is this?"
msgstr "Co je tohle?"

#: src/pages/catchup.jsx:915
msgid "Catch-up is a separate timeline for your followings, offering a high-level view at a glance, with a simple, email-inspired interface to effortlessly sort and filter through posts."
msgstr "Catch-up je samostatná časová osa pro sledované uživatele, která nabízí přehledný pohled na příspěvky s jednoduchým rozhraním inspirovaným e-mailem, což umožňuje snadné třídění a filtrování obsahu."

#: src/pages/catchup.jsx:926
msgid "Preview of Catch-up UI"
msgstr "Náhled rozhraní Catch-up"

#: src/pages/catchup.jsx:935
msgid "Let's catch up"
msgstr "Rychlá rekapitulace"

#: src/pages/catchup.jsx:940
msgid "Let's catch up on the posts from your followings."
msgstr "Rekapitulace příspěvků od těch, které sledujete."

#: src/pages/catchup.jsx:944
msgid "Show me all posts from…"
msgstr "Zobrazit všechny příspěvky od…"

#: src/pages/catchup.jsx:967
msgid "until the max"
msgstr "až do maxima"

#: src/pages/catchup.jsx:997
msgid "Catch up"
msgstr "Catch up"

#: src/pages/catchup.jsx:1003
msgid "Overlaps with your last catch-up"
msgstr "Překrývá se s vaší poslední rekapitulací"

#. placeholder {0}: dtf.format(new Date(lastCatchupEndAt))
#: src/pages/catchup.jsx:1015
msgid "Until the last catch-up ({0})"
msgstr ""

#: src/pages/catchup.jsx:1024
msgid "Note: your instance might only show a maximum of 800 posts in the Home timeline regardless of the time range. Could be less or more."
msgstr "Poznámka: Vaše instance může zobrazit maximálně 800 příspěvků na domovské časové ose, bez ohledu na časové rozmezí. Může to být méně nebo více."

#: src/pages/catchup.jsx:1034
msgid "Previously…"
msgstr "Předchozí…"

#. placeholder {0}: pc.count
#: src/pages/catchup.jsx:1052
msgid "{0, plural, one {# post} other {# posts}}"
msgstr "{0, plural, one {# příspěvek} few {# příspěvky} many {# příspěvků} other {# příspěvků}}"

#: src/pages/catchup.jsx:1062
msgid "Remove this catch-up?"
msgstr "Odstranit tuto rekapitulaci?"

#. placeholder {0}: pc.id
#: src/pages/catchup.jsx:1065
msgid "Removing Catch-up {0}"
msgstr ""

#. placeholder {1}: pc.id
#: src/pages/catchup.jsx:1069
msgid "Catch-up {1} removed"
msgstr ""

#: src/pages/catchup.jsx:1083
msgid "Note: Only max 3 will be stored. The rest will be automatically removed."
msgstr "Poznámka: Budou uloženy pouze maximálně 3. Zbytek bude automaticky odstraněn."

#: src/pages/catchup.jsx:1098
msgid "Fetching posts…"
msgstr "Načítání příspěvků…"

#: src/pages/catchup.jsx:1101
msgid "This might take a while."
msgstr "To může chvíli trvat."

#: src/pages/catchup.jsx:1136
msgid "Reset filters"
msgstr "Obnovit filtry"

#: src/pages/catchup.jsx:1144
#: src/pages/catchup.jsx:1591
msgid "Top links"
msgstr "Nejlepší odkazy"

#. placeholder {0}: sharers.map((s) => { const { avatarStatic, displayName } = s; return ( <button type="button" class="plain" style={{ padding: 0, }} onClick={(e) => { e.preventDefault(); e.stopPropagation(); // Reset and filter to author const { id } = s; setSelectedAuthor(id); setSelectedFilterCategory('all'); }} > <Avatar url={avatarStatic} size="s" alt={displayName} /> </button> ); })
#: src/pages/catchup.jsx:1261
msgid "Shared by {0}"
msgstr "Sdílel/a {0}"

#: src/pages/catchup.jsx:1316
#: src/pages/mentions.jsx:148
#: src/pages/search.jsx:313
msgid "All"
msgstr "Vše"

#. placeholder {0}: authorCountsList.length
#: src/pages/catchup.jsx:1401
msgid "{0, plural, one {# author} other {# authors}}"
msgstr "{0, plural, one {# autor} few {# autoři} many {# autorů} other {# autorů}}"

#: src/pages/catchup.jsx:1413
msgid "Sort"
msgstr "Seřadit"

#: src/pages/catchup.jsx:1444
msgid "Date"
msgstr "Datum"

#: src/pages/catchup.jsx:1448
msgid "Density"
msgstr "Hustota"

#. js-lingui-explicit-id
#: src/pages/catchup.jsx:1471
msgid "group.filter"
msgstr ""

#: src/pages/catchup.jsx:1486
msgid "Authors"
msgstr "Autoři"

#: src/pages/catchup.jsx:1487
msgid "None"
msgstr "Žádný"

#: src/pages/catchup.jsx:1503
msgid "Show all authors"
msgstr "Zobrazit všechny autory"

#: src/pages/catchup.jsx:1554
msgid "You don't have to read everything."
msgstr "Není třeba číst všechno."

#: src/pages/catchup.jsx:1555
msgid "That's all."
msgstr "To je vše."

#: src/pages/catchup.jsx:1563
msgid "Back to top"
msgstr "Zpět na začátek"

#: src/pages/catchup.jsx:1594
msgid "Links shared by followings, sorted by shared counts, boosts and likes."
msgstr "Odkazy sdílené lidmi, které sledujete, seřazené podle počtu sdílení, boostů a lajků."

#: src/pages/catchup.jsx:1600
msgid "Sort: Density"
msgstr "Třídit: Hustota"

#: src/pages/catchup.jsx:1603
msgid "Posts are sorted by information density or depth. Shorter posts are \"lighter\" while longer posts are \"heavier\". Posts with photos are \"heavier\" than posts without photos."
msgstr "Příspěvky jsou tříděny podle informační hustoty nebo hloubky. kratší příspěvky jsou \"lehčí\" zatímco delší příspěvky jsou \"těžší\". Příspěvky s fotkami jsou \"těžší\" než příspěvky bez fotografií."

#: src/pages/catchup.jsx:1610
msgid "Group: Authors"
msgstr "Skupina: Autoři"

#: src/pages/catchup.jsx:1613
msgid "Posts are grouped by authors, sorted by posts count per author."
msgstr "Příspěvky jsou seskupeny podle autorů a seřazeny podle počtu příspěvků na autora."

#: src/pages/catchup.jsx:1660
msgid "Next author"
msgstr "Další autor"

#: src/pages/catchup.jsx:1668
msgid "Previous author"
msgstr "Předchozí autor"

#: src/pages/catchup.jsx:1684
msgid "Scroll to top"
msgstr "Přejít na začátek"

#. placeholder {0}: filterInfo.titlesStr
#: src/pages/catchup.jsx:1876
msgid "Filtered: {0}"
msgstr "Filtrováno: {0}"

#: src/pages/favourites.jsx:26
msgid "No likes yet. Go like something!"
msgstr ""

#: src/pages/favourites.jsx:27
msgid "Unable to load likes."
msgstr "Nepodařilo se načíst lajky."

#: src/pages/filters.jsx:22
msgid "Home and lists"
msgstr "Domovská časová osa a seznamy"

#: src/pages/filters.jsx:24
msgid "Public timelines"
msgstr "Veřejná časová osa"

#: src/pages/filters.jsx:25
msgid "Conversations"
msgstr "Konverzace"

#: src/pages/filters.jsx:26
msgid "Profiles"
msgstr "Profily"

#: src/pages/filters.jsx:41
msgid "Never"
msgstr "Nikdy"

#: src/pages/filters.jsx:103
#: src/pages/filters.jsx:228
msgid "New filter"
msgstr "Nový filtr"

#. placeholder {0}: filters.length
#: src/pages/filters.jsx:151
msgid "{0, plural, one {# filter} other {# filters}}"
msgstr "{0, plural, one {# filtr} few {# filtry} many {# filtrů} other {# filtrů}}"

#: src/pages/filters.jsx:166
msgid "Unable to load filters."
msgstr "Nepodařilo se načíst filtry."

#: src/pages/filters.jsx:170
msgid "No filters yet."
msgstr "Zatím žádné filtry."

#: src/pages/filters.jsx:177
msgid "Add filter"
msgstr "Přidat filtr"

#: src/pages/filters.jsx:228
msgid "Edit filter"
msgstr "Upravit filtr"

#: src/pages/filters.jsx:345
msgid "Unable to edit filter"
msgstr "Nepodařilo se upravit filtr"

#: src/pages/filters.jsx:346
msgid "Unable to create filter"
msgstr "Nelze vytvořit filtr"

#: src/pages/filters.jsx:355
msgid "Title"
msgstr "Název"

#: src/pages/filters.jsx:396
msgid "Whole word"
msgstr "Celé slovo"

#: src/pages/filters.jsx:422
msgid "No keywords. Add one."
msgstr "Žádná klíčová slova. Přidejte jedno."

#: src/pages/filters.jsx:449
msgid "Add keyword"
msgstr "Přidat klíčové slovo"

#. placeholder {0}: filteredEditKeywords.length
#: src/pages/filters.jsx:453
msgid "{0, plural, one {# keyword} other {# keywords}}"
msgstr "{0, plural, one {# klíčové slovo} few {# klíčová slova} many {# klíčových slov} other {# klíčových slov}}"

#: src/pages/filters.jsx:466
msgid "Filter from…"
msgstr "Filtrovat od…"

#: src/pages/filters.jsx:492
msgid "* Not implemented yet"
msgstr "* Zatím není implementováno"

#: src/pages/filters.jsx:498
msgid "Status: <0><1/></0>"
msgstr "Stav: <0><1/></0>"

#: src/pages/filters.jsx:507
msgid "Change expiry"
msgstr "Změnit vypršení platnosti"

#: src/pages/filters.jsx:507
msgid "Expiry"
msgstr "Vypršení platnosti"

#: src/pages/filters.jsx:526
msgid "Filtered post will be…"
msgstr ""

#: src/pages/filters.jsx:536
msgid "minimized"
msgstr "minimalizovat"

#: src/pages/filters.jsx:546
msgid "hidden"
msgstr "skrytý"

#: src/pages/filters.jsx:563
msgid "Delete this filter?"
msgstr "Smazat tento filtr?"

#: src/pages/filters.jsx:576
msgid "Unable to delete filter."
msgstr "Nepodařilo se odstranit filtr."

#: src/pages/filters.jsx:609
msgid "Expired"
msgstr "Vypršelo"

#: src/pages/filters.jsx:611
msgid "Expiring <0/>"
msgstr ""

#: src/pages/filters.jsx:615
msgid "Never expires"
msgstr ""

#. placeholder {0}: followedHashtags.length
#: src/pages/followed-hashtags.jsx:71
msgid "{0, plural, one {# hashtag} other {# hashtags}}"
msgstr ""

#: src/pages/followed-hashtags.jsx:86
msgid "Unable to load followed hashtags."
msgstr "Nepodařilo se načíst sledované hashtagy."

#: src/pages/followed-hashtags.jsx:90
msgid "No hashtags followed yet."
msgstr "Zatím nesledujete žádné hashtagy."

#: src/pages/following.jsx:144
msgid "Nothing to see here."
msgstr "Není zde nic k zobrazení."

#: src/pages/following.jsx:145
#: src/pages/list.jsx:109
msgid "Unable to load posts."
msgstr "Nelze načíst příspěvky."

#: src/pages/hashtag.jsx:56
msgid "{hashtagTitle} (Media only) on {instance}"
msgstr ""

#: src/pages/hashtag.jsx:57
msgid "{hashtagTitle} on {instance}"
msgstr ""

#: src/pages/hashtag.jsx:59
msgid "{hashtagTitle} (Media only)"
msgstr ""

#: src/pages/hashtag.jsx:60
msgid "{hashtagTitle}"
msgstr ""

#: src/pages/hashtag.jsx:182
msgid "No one has posted anything with this tag yet."
msgstr "S tímto štítkem zatím nikdo nic nepřidal."

#: src/pages/hashtag.jsx:183
msgid "Unable to load posts with this tag"
msgstr "Nepodařilo se načíst příspěvky s tímto štítkem"

#: src/pages/hashtag.jsx:209
msgid "Unfollow #{hashtag}?"
msgstr ""

#: src/pages/hashtag.jsx:224
msgid "Unfollowed #{hashtag}"
msgstr "#{hashtag} již není sledován"

#: src/pages/hashtag.jsx:239
msgid "Followed #{hashtag}"
msgstr ""

#: src/pages/hashtag.jsx:255
msgid "Following…"
msgstr ""

#: src/pages/hashtag.jsx:283
msgid "Unfeatured on profile"
msgstr ""

#: src/pages/hashtag.jsx:297
msgid "Unable to unfeature on profile"
msgstr ""

#: src/pages/hashtag.jsx:306
#: src/pages/hashtag.jsx:322
msgid "Featured on profile"
msgstr ""

#: src/pages/hashtag.jsx:329
msgid "Feature on profile"
msgstr ""

#: src/pages/hashtag.jsx:394
msgid "{TOTAL_TAGS_LIMIT, plural, other {Max # tags}}"
msgstr "{TOTAL_TAGS_LIMIT, plural, one {} few {#} many {#}other {#}}"

#: src/pages/hashtag.jsx:397
msgid "Add hashtag"
msgstr "Přidat hashtag"

#: src/pages/hashtag.jsx:429
msgid "Remove hashtag"
msgstr "Odstranit hashtag"

#: src/pages/hashtag.jsx:443
msgid "{SHORTCUTS_LIMIT, plural, one {Max # shortcut reached. Unable to add shortcut.} other {Max # shortcuts reached. Unable to add shortcut.}}"
msgstr ""

#: src/pages/hashtag.jsx:472
msgid "This shortcut already exists"
msgstr ""

#: src/pages/hashtag.jsx:475
msgid "Hashtag shortcut added"
msgstr ""

#: src/pages/hashtag.jsx:481
msgid "Add to Shortcuts"
msgstr "Přidat do zkratek"

#: src/pages/hashtag.jsx:487
#: src/pages/public.jsx:140
#: src/pages/trending.jsx:479
msgid "Enter a new instance e.g. \"mastodon.social\""
msgstr "Zadejte novou instanci, např. „mastodon.social“"

#: src/pages/hashtag.jsx:490
#: src/pages/public.jsx:143
#: src/pages/trending.jsx:482
msgid "Invalid instance"
msgstr "Neplatná instance"

#: src/pages/hashtag.jsx:504
#: src/pages/public.jsx:157
#: src/pages/trending.jsx:494
msgid "Go to another instance…"
msgstr "Přejít na jinou instanci…"

#: src/pages/hashtag.jsx:517
#: src/pages/public.jsx:170
#: src/pages/trending.jsx:505
msgid "Go to my instance (<0>{currentInstance}</0>)"
msgstr "Přejít na moji instanci (<0>{currentInstance}</0>)"

#: src/pages/home.jsx:210
msgid "Unable to fetch notifications."
msgstr ""

#: src/pages/home.jsx:230
msgid "<0>New</0> <1>Follow Requests</1>"
msgstr ""

#: src/pages/home.jsx:236
msgid "See all"
msgstr ""

#: src/pages/http-route.jsx:68
msgid "Resolving…"
msgstr ""

#: src/pages/http-route.jsx:79
msgid "Unable to resolve URL"
msgstr ""

#: src/pages/list.jsx:108
msgid "Nothing yet."
msgstr ""

#: src/pages/list.jsx:177
#: src/pages/list.jsx:281
msgid "Manage members"
msgstr ""

#. placeholder {0}: account.username
#: src/pages/list.jsx:316
msgid "Remove <0>@{0}</0> from list?"
msgstr ""

#: src/pages/list.jsx:362
msgid "Remove…"
msgstr ""

#. placeholder {0}: lists.length
#: src/pages/lists.jsx:94
msgid "{0, plural, one {# list} other {# lists}}"
msgstr ""

#: src/pages/lists.jsx:109
msgid "No lists yet."
msgstr ""

#: src/pages/login.jsx:110
#: src/pages/login.jsx:123
msgid "Failed to register application"
msgstr ""

#: src/pages/login.jsx:209
msgid "instance domain"
msgstr ""

#: src/pages/login.jsx:233
msgid "e.g. “mastodon.social”"
msgstr ""

#: src/pages/login.jsx:244
msgid "Failed to log in. Please try again or try another instance."
msgstr ""

#: src/pages/login.jsx:256
msgid "Continue with {selectedInstanceText}"
msgstr ""

#: src/pages/login.jsx:257
msgid "Continue"
msgstr ""

#: src/pages/login.jsx:265
msgid "Don't have an account? Create one!"
msgstr "Nemáte účet? Vytvořte si účet!"

#: src/pages/mentions.jsx:21
msgid "Private mentions"
msgstr "Soukromé zmínky"

#: src/pages/mentions.jsx:160
msgid "Private"
msgstr "Soukromý"

#: src/pages/mentions.jsx:170
msgid "No one mentioned you :("
msgstr "Nikdo vás nezmínil :("

#: src/pages/mentions.jsx:171
msgid "Unable to load mentions."
msgstr "Nepodařilo se načíst odpovědi."

#: src/pages/notifications.jsx:104
msgid "You don't follow"
msgstr "Nesledujete"

#: src/pages/notifications.jsx:105
msgid "Who don't follow you"
msgstr "Kdo tě nesleduje"

#: src/pages/notifications.jsx:106
msgid "With a new account"
msgstr "S novým účtem"

#: src/pages/notifications.jsx:107
msgid "Who unsolicitedly private mention you"
msgstr ""

#: src/pages/notifications.jsx:108
msgid "Who are limited by server moderators"
msgstr ""

#: src/pages/notifications.jsx:578
#: src/pages/notifications.jsx:919
msgid "Notifications settings"
msgstr "Nastavení oznámení"

#: src/pages/notifications.jsx:596
msgid "New notifications"
msgstr "Nová oznámení"

#. placeholder {0}: announcements.length
#: src/pages/notifications.jsx:607
msgid "{0, plural, one {Announcement} other {Announcements}}"
msgstr ""

#: src/pages/notifications.jsx:654
#: src/pages/settings.jsx:1163
msgid "Follow requests"
msgstr ""

#. placeholder {0}: followRequests.length
#: src/pages/notifications.jsx:659
msgid "{0, plural, one {# follow request} other {# follow requests}}"
msgstr ""

#. placeholder {0}: notificationsPolicy.summary.pendingRequestsCount
#: src/pages/notifications.jsx:714
msgid "{0, plural, one {Filtered notifications from # person} other {Filtered notifications from # people}}"
msgstr ""

#: src/pages/notifications.jsx:787
msgid "Only mentions"
msgstr "Pouze @zmínky"

#: src/pages/notifications.jsx:791
msgid "Today"
msgstr "Dnes"

#: src/pages/notifications.jsx:796
msgid "You're all caught up."
msgstr ""

#: src/pages/notifications.jsx:819
msgid "Yesterday"
msgstr "Včera"

#: src/pages/notifications.jsx:867
msgid "Unable to load notifications"
msgstr "Nelze načíst oznámení"

#: src/pages/notifications.jsx:946
msgid "Notifications settings updated"
msgstr "Nastavení oznámení aktualizováno"

#: src/pages/notifications.jsx:954
msgid "Filter out notifications from people:"
msgstr "Filtrovat oznámení od lidí:"

#: src/pages/notifications.jsx:968
msgid "Filter"
msgstr "Filtr"

#: src/pages/notifications.jsx:971
msgid "Ignore"
msgstr "Ignorovat"

#. placeholder {0}: niceDateTime(updatedAtDate)
#: src/pages/notifications.jsx:1044
msgid "Updated <0>{0}</0>"
msgstr "Aktualizováno <0>{0}</0>"

#. placeholder {0}: account.username
#: src/pages/notifications.jsx:1112
msgid "View notifications from <0>@{0}</0>"
msgstr ""

#. placeholder {0}: account.username
#: src/pages/notifications.jsx:1133
msgid "Notifications from <0>@{0}</0>"
msgstr ""

#. placeholder {0}: request.account.username
#: src/pages/notifications.jsx:1201
msgid "Notifications from @{0} will not be filtered from now on."
msgstr ""

#: src/pages/notifications.jsx:1206
msgid "Unable to accept notification request"
msgstr ""

#: src/pages/notifications.jsx:1211
msgid "Allow"
msgstr "Povolit"

#. placeholder {1}: request.account.username
#: src/pages/notifications.jsx:1231
msgid "Notifications from @{1} will not show up in Filtered notifications from now on."
msgstr ""

#: src/pages/notifications.jsx:1236
msgid "Unable to dismiss notification request"
msgstr ""

#: src/pages/notifications.jsx:1241
msgid "Dismiss"
msgstr "Odmítnout"

#: src/pages/notifications.jsx:1256
msgid "Dismissed"
msgstr ""

#: src/pages/public.jsx:28
msgid "Local timeline ({instance})"
msgstr "Místní časová osa ({instance})"

#: src/pages/public.jsx:29
msgid "Federated timeline ({instance})"
msgstr "Federovaná časová osa ({instance})"

#: src/pages/public.jsx:91
msgid "Local timeline"
msgstr "Místní časová osa"

#: src/pages/public.jsx:91
msgid "Federated timeline"
msgstr "Federovaná časová osa"

#: src/pages/public.jsx:97
msgid "No one has posted anything yet."
msgstr ""

#: src/pages/public.jsx:124
msgid "Switch to Federated"
msgstr ""

#: src/pages/public.jsx:131
msgid "Switch to Local"
msgstr ""

#: src/pages/search.jsx:50
msgid "Search: {q} (Posts)"
msgstr ""

#: src/pages/search.jsx:53
msgid "Search: {q} (Accounts)"
msgstr ""

#: src/pages/search.jsx:56
msgid "Search: {q} (Hashtags)"
msgstr ""

#: src/pages/search.jsx:59
msgid "Search: {q}"
msgstr ""

#: src/pages/search.jsx:323
#: src/pages/search.jsx:405
msgid "Hashtags"
msgstr "Hashtagy"

#: src/pages/search.jsx:355
#: src/pages/search.jsx:409
#: src/pages/search.jsx:479
msgid "See more"
msgstr ""

#: src/pages/search.jsx:381
msgid "See more accounts"
msgstr "Zobrazit další účty"

#: src/pages/search.jsx:395
msgid "No accounts found."
msgstr ""

#: src/pages/search.jsx:451
msgid "See more hashtags"
msgstr ""

#: src/pages/search.jsx:465
msgid "No hashtags found."
msgstr ""

#: src/pages/search.jsx:509
msgid "See more posts"
msgstr "Zobrazit více příspěvků"

#: src/pages/search.jsx:523
msgid "No posts found."
msgstr ""

#: src/pages/search.jsx:567
msgid "Enter your search term or paste a URL above to get started."
msgstr ""

#: src/pages/settings.jsx:83
msgid "Settings"
msgstr "Nastavení"

#: src/pages/settings.jsx:92
msgid "Appearance"
msgstr "Vzhled"

#: src/pages/settings.jsx:168
msgid "Light"
msgstr ""

#: src/pages/settings.jsx:179
msgid "Dark"
msgstr ""

#: src/pages/settings.jsx:192
msgid "Auto"
msgstr ""

#: src/pages/settings.jsx:202
msgid "Text size"
msgstr "Velikost textu"

#. Preview of one character, in smallest size
#. Preview of one character, in largest size
#: src/pages/settings.jsx:207
#: src/pages/settings.jsx:232
msgid "A"
msgstr ""

#: src/pages/settings.jsx:246
msgid "Display language"
msgstr ""

#: src/pages/settings.jsx:255
msgid "Volunteer translations"
msgstr ""

#: src/pages/settings.jsx:266
msgid "Posting"
msgstr ""

#: src/pages/settings.jsx:273
msgid "Default visibility"
msgstr ""

#: src/pages/settings.jsx:274
#: src/pages/settings.jsx:320
msgid "Synced"
msgstr ""

#: src/pages/settings.jsx:299
msgid "Failed to update posting privacy"
msgstr ""

#: src/pages/settings.jsx:322
msgid "Synced to your instance server's settings. <0>Go to your instance ({instance}) for more settings.</0>"
msgstr ""

#: src/pages/settings.jsx:337
msgid "Experiments"
msgstr ""

#: src/pages/settings.jsx:350
msgid "Auto refresh timeline posts"
msgstr ""

#: src/pages/settings.jsx:362
msgid "Boosts carousel"
msgstr ""

#: src/pages/settings.jsx:378
msgid "Post translation"
msgstr ""

#: src/pages/settings.jsx:389
msgid "Translate to "
msgstr ""

#: src/pages/settings.jsx:400
msgid "System language ({systemTargetLanguageText})"
msgstr ""

#. placeholder {0}: snapStates.settings.contentTranslationHideLanguages.length
#: src/pages/settings.jsx:426
msgid "{0, plural, =0 {Hide \"Translate\" button for:} other {Hide \"Translate\" button for (#):}}"
msgstr ""

#: src/pages/settings.jsx:480
msgid "Note: This feature uses external translation services, powered by <0>Lingva API</0> & <1>Lingva Translate</1>."
msgstr ""

#: src/pages/settings.jsx:514
msgid "Auto inline translation"
msgstr ""

#: src/pages/settings.jsx:518
msgid "Automatically show translation for posts in timeline. Only works for <0>short</0> posts without content warning, media and poll."
msgstr ""

#: src/pages/settings.jsx:538
msgid "GIF Picker for composer"
msgstr ""

#: src/pages/settings.jsx:542
msgid "Note: This feature uses external GIF search service, powered by <0>GIPHY</0>. G-rated (suitable for viewing by all ages), tracking parameters are stripped, referrer information is omitted from requests, but search queries and IP address information will still reach their servers."
msgstr ""

#: src/pages/settings.jsx:571
msgid "Image description generator"
msgstr "Generátor popisu obrázků"

#: src/pages/settings.jsx:576
msgid "Only for new images while composing new posts."
msgstr ""

#: src/pages/settings.jsx:583
msgid "Note: This feature uses external AI service, powered by <0>img-alt-api</0>. May not work well. Only for images and in English."
msgstr ""

#: src/pages/settings.jsx:609
msgid "Server-side grouped notifications"
msgstr ""

#: src/pages/settings.jsx:613
msgid "Alpha-stage feature. Potentially improved grouping window but basic grouping logic."
msgstr ""

#: src/pages/settings.jsx:634
msgid "\"Cloud\" import/export for shortcuts settings"
msgstr ""

#: src/pages/settings.jsx:639
msgid "⚠️⚠️⚠️ Very experimental.<0/>Stored in your own profile’s notes. Profile (private) notes are mainly used for other profiles, and hidden for own profile."
msgstr ""

#: src/pages/settings.jsx:650
msgid "Note: This feature uses currently-logged-in instance server API."
msgstr ""

#: src/pages/settings.jsx:667
msgid "Cloak mode <0>(<1>Text</1> → <2>████</2>)</0>"
msgstr ""

#: src/pages/settings.jsx:676
msgid "Replace text as blocks, useful when taking screenshots, for privacy reasons."
msgstr ""

#: src/pages/settings.jsx:701
msgid "About"
msgstr ""

#: src/pages/settings.jsx:740
msgid "<0>Built</0> by <1>@cheeaun</1>"
msgstr ""

#: src/pages/settings.jsx:769
msgid "Sponsor"
msgstr ""

#: src/pages/settings.jsx:777
msgid "Donate"
msgstr "Přispět"

#: src/pages/settings.jsx:793
msgid "Privacy Policy"
msgstr "Ochrana osobních údajů"

#. placeholder {0}: WEBSITE.replace(/https?:\/\//g, '').replace(/\/$/, '')
#: src/pages/settings.jsx:800
msgid "<0>Site:</0> {0}"
msgstr ""

#. placeholder {0}: !__FAKE_COMMIT_HASH__ && ( <span class="ib insignificant"> ( <a href={`https://github.com/cheeaun/phanpy/commit/${__COMMIT_HASH__}`} target="_blank" rel="noopener noreferrer" > <RelativeTime datetime={new Date(__BUILD_TIME__)} /> </a> ) </span> )
#: src/pages/settings.jsx:807
msgid "<0>Version:</0> <1/> {0}"
msgstr "<0>Verze:</0> <1/> {0}"

#: src/pages/settings.jsx:822
msgid "Version string copied"
msgstr ""

#: src/pages/settings.jsx:825
msgid "Unable to copy version string"
msgstr ""

#: src/pages/settings.jsx:1060
#: src/pages/settings.jsx:1065
msgid "Failed to update subscription. Please try again."
msgstr ""

#: src/pages/settings.jsx:1071
msgid "Failed to remove subscription. Please try again."
msgstr ""

#: src/pages/settings.jsx:1078
msgid "Push Notifications (beta)"
msgstr "Push notifikace (beta)"

#: src/pages/settings.jsx:1100
msgid "Push notifications are blocked. Please enable them in your browser settings."
msgstr ""

#. placeholder {0}: [ { value: 'all', label: t`anyone`, }, { value: 'followed', label: t`people I follow`, }, { value: 'follower', label: t`followers`, }, ].map((type) => ( <option value={type.value}>{type.label}</option> ))
#: src/pages/settings.jsx:1109
msgid "Allow from <0>{0}</0>"
msgstr ""

#: src/pages/settings.jsx:1118
msgid "anyone"
msgstr ""

#: src/pages/settings.jsx:1122
msgid "people I follow"
msgstr ""

#: src/pages/settings.jsx:1126
msgid "followers"
msgstr ""

#: src/pages/settings.jsx:1159
msgid "Follows"
msgstr ""

#: src/pages/settings.jsx:1167
msgid "Polls"
msgstr "Ankety"

#: src/pages/settings.jsx:1171
msgid "Post edits"
msgstr ""

#: src/pages/settings.jsx:1192
msgid "Push permission was not granted since your last login. You'll need to <0><1>log in</1> again to grant push permission</0>."
msgstr ""

#: src/pages/settings.jsx:1208
msgid "NOTE: Push notifications only work for <0>one account</0>."
msgstr ""

#. js-lingui-explicit-id
#: src/pages/status.jsx:599
#: src/pages/status.jsx:1133
msgid "post.title"
msgstr ""

#: src/pages/status.jsx:824
msgid "You're not logged in. Interactions (reply, boost, etc) are not possible."
msgstr ""

#: src/pages/status.jsx:844
msgid "This post is from another instance (<0>{instance}</0>). Interactions (reply, boost, etc) are not possible."
msgstr ""

#: src/pages/status.jsx:872
msgid "Error: {e}"
msgstr "Chyba: {e}"

#: src/pages/status.jsx:879
msgid "Switch to my instance to enable interactions"
msgstr ""

#: src/pages/status.jsx:981
msgid "Unable to load replies."
msgstr "Nepodařilo se načíst odpovědi."

#: src/pages/status.jsx:1093
msgid "Back"
msgstr "Zpět"

#: src/pages/status.jsx:1124
msgid "Go to main post"
msgstr ""

#. placeholder {0}: ancestors.length
#: src/pages/status.jsx:1147
msgid "{0} posts above ‒ Go to top"
msgstr ""

#: src/pages/status.jsx:1190
#: src/pages/status.jsx:1253
msgid "Switch to Side Peek view"
msgstr ""

#: src/pages/status.jsx:1254
msgid "Switch to Full view"
msgstr ""

#: src/pages/status.jsx:1272
msgid "Show all sensitive content"
msgstr ""

#: src/pages/status.jsx:1277
msgid "Experimental"
msgstr ""

#: src/pages/status.jsx:1286
msgid "Unable to switch"
msgstr ""

#. placeholder {1}: punycode.toUnicode( postInstance, )
#: src/pages/status.jsx:1293
msgid "Switch to post's instance ({1})"
msgstr ""

#: src/pages/status.jsx:1296
msgid "Switch to post's instance"
msgstr ""

#: src/pages/status.jsx:1354
msgid "Unable to load post"
msgstr ""

#. placeholder {0}: replies.length
#. placeholder {1}: shortenNumber(replies.length)
#: src/pages/status.jsx:1490
msgid "{0, plural, one {# reply} other {<0>{1}</0> replies}}"
msgstr ""

#. placeholder {0}: shortenNumber(totalComments)
#: src/pages/status.jsx:1508
msgid "{totalComments, plural, one {# comment} other {<0>{0}</0> comments}}"
msgstr ""

#: src/pages/status.jsx:1530
msgid "View post with its replies"
msgstr ""

#: src/pages/trending.jsx:72
msgid "Trending ({instance})"
msgstr ""

#: src/pages/trending.jsx:229
msgid "Trending News"
msgstr ""

#. By [Author]
#. placeholder {0}: author ? ( <NameText account={author} showAvatar /> ) : authorUrl ? ( <a href={authorUrl} target="_blank" rel="noopener noreferrer" > {authorName} </a> ) : ( authorName )
#: src/pages/trending.jsx:348
msgid "By {0}"
msgstr ""

#: src/pages/trending.jsx:409
msgid "Back to showing trending posts"
msgstr ""

#. placeholder {0}: currentLink .replace(/^https?:\/\/(www\.)?/i, '') .replace(/\/$/, '')
#: src/pages/trending.jsx:414
msgid "Showing posts mentioning <0>{0}</0>"
msgstr ""

#: src/pages/trending.jsx:426
msgid "Trending posts"
msgstr ""

#: src/pages/trending.jsx:449
msgid "No trending posts."
msgstr ""

#: src/pages/welcome.jsx:54
msgid "A minimalistic opinionated Mastodon web client."
msgstr ""

#: src/pages/welcome.jsx:65
msgid "Log in with Mastodon"
msgstr ""

#: src/pages/welcome.jsx:71
msgid "Sign up"
msgstr ""

#: src/pages/welcome.jsx:78
msgid "Connect your existing Mastodon/Fediverse account.<0/>Your credentials are not stored on this server."
msgstr ""

#: src/pages/welcome.jsx:95
msgid "<0>Built</0> by <1>@cheeaun</1>. <2>Privacy Policy</2>."
msgstr ""

#: src/pages/welcome.jsx:126
msgid "Screenshot of Boosts Carousel"
msgstr ""

#: src/pages/welcome.jsx:130
msgid "Boosts Carousel"
msgstr ""

#: src/pages/welcome.jsx:133
msgid "Visually separate original posts and re-shared posts (boosted posts)."
msgstr ""

#: src/pages/welcome.jsx:142
msgid "Screenshot of nested comments thread"
msgstr ""

#: src/pages/welcome.jsx:146
msgid "Nested comments thread"
msgstr ""

#: src/pages/welcome.jsx:149
msgid "Effortlessly follow conversations. Semi-collapsible replies."
msgstr ""

#: src/pages/welcome.jsx:157
msgid "Screenshot of grouped notifications"
msgstr ""

#: src/pages/welcome.jsx:161
msgid "Grouped notifications"
msgstr ""

#: src/pages/welcome.jsx:164
msgid "Similar notifications are grouped and collapsed to reduce clutter."
msgstr ""

#: src/pages/welcome.jsx:173
msgid "Screenshot of multi-column UI"
msgstr ""

#: src/pages/welcome.jsx:177
msgid "Single or multi-column"
msgstr ""

#: src/pages/welcome.jsx:180
msgid "By default, single column for zen-mode seekers. Configurable multi-column for power users."
msgstr ""

#: src/pages/welcome.jsx:189
msgid "Screenshot of multi-hashtag timeline with a form to add more hashtags"
msgstr ""

#: src/pages/welcome.jsx:193
msgid "Multi-hashtag timeline"
msgstr ""

#: src/pages/welcome.jsx:196
msgid "Up to 5 hashtags combined into a single timeline."
msgstr ""

#: src/utils/open-compose.js:24
msgid "Looks like your browser is blocking popups."
msgstr ""

#: src/utils/show-compose.js:16
msgid "A draft post is currently minimized. Post or discard it before creating a new one."
msgstr ""

#: src/utils/show-compose.js:21
msgid "A post is currently open. Post or discard it before creating a new one."
msgstr ""

